import type { MessageKey } from './en';

/** Hebrew UI strings. Must contain every key in en.ts — TypeScript enforces it. */
export const he: Record<MessageKey, string> = {
  'app.name': 'משפחת אדרי',
  'app.tagline': 'לראות את המשפחה, להבין את הקשרים ולשמור את הסיפורים שמאחורי האנשים.',
  'nav.tree': 'עץ המשפחה',
  'nav.timeline': 'ציר זמן',
  'nav.me': 'הפרופיל שלי',
  'nav.manage': 'ניהול המשפחה',
  'nav.admin': 'בקרות מנהל',
  'nav.settings': 'הגדרות',
  'settings.advanced': 'מצב מתקדם',
  'admin.mode': 'מצב מנהל',
  'admin.mode.needed': 'הפעילו מצב מנהל בתפריט כדי לנהל את המשפחה.',
  'nav.notifications': 'התראות',
  'nav.record': 'להקליט סיפור',
  'nav.back': 'חזרה',
  'nav.close': 'סגירה',
  'nav.skip': 'דילוג',
  'nav.next': 'הבא',
  'nav.done': 'סיום',
  'nav.cancel': 'ביטול',
  'nav.save': 'שמירה',
  'nav.continue': 'המשך',
  'nav.tryAgain': 'לנסות שוב',
  'nav.menu': 'תפריט',
  'nav.viewingAs': 'מחובר/ת בתור {name}',
  'lang.switch': 'English',
  'lang.switchLabel': 'החלפת שפה לאנגלית',
  'lang.current': 'עברית',

  'common.loading': 'טוען…',
  'common.saved': 'נשמר',
  'common.saving': 'שומר…',
  'common.notBackedUp': 'עדיין לא גובה',
  'common.couldNotSave': 'לא ניתן היה לשמור',
  'common.offline': 'אין חיבור לאינטרנט. השינויים נשמרים במכשיר הזה ויישלחו כשהחיבור יחזור.',
  'common.reconnected': 'החיבור חזר. שולח את השינויים ששמרת…',
  'common.storageUnavailable': 'לא ניתן היה לפתוח את האחסון של הדפדפן, ולכן תמונות והקלטות ששמורות במכשיר הזה לא מוצגות כרגע. שום דבר לא אבד.',
  'common.reloadPage': 'לטעון מחדש',
  'common.pendingCount': '{count} שינויים ממתינים לשליחה',
  'common.retryNow': 'לשלוח עכשיו',
  'common.discard': 'למחוק',
  'common.remove': 'להסיר',
  'common.yes': 'כן',
  'common.no': 'לא',
  'common.unknown': 'לא ידוע',
  'common.none': 'אין',
  'common.optional': 'לא חובה',
  'common.required': 'חובה',
  'common.search': 'חיפוש',
  'common.clear': 'ניקוי',
  'common.more': 'עוד',
  'common.less': 'פחות',
  'common.all': 'הכול',
  'common.confirm': 'אישור',
  'common.you': 'את/ה',
  'common.by': 'על ידי {name}',
  'common.at': 'ב-{time}',
  'common.error.title': 'משהו השתבש',
  'common.nothingLost': 'שום דבר לא אבד.',
  'common.livingStatus.living': 'בחיים',
  'common.livingStatus.deceased': 'נפטר/ה',
  'common.livingStatus.unknown': 'לא ידוע',
  'common.gender.female': 'נקבה',
  'common.gender.male': 'זכר',
  'common.gender.other': 'אחר',
  'common.gender.unspecified': 'מעדיפ/ה לא לציין',
  'common.role.member': 'חבר/ת משפחה',
  'common.role.helper': 'עוזר/ת פרופיל',
  'common.role.editor': 'עורך/ת משפחה',
  'common.role.admin': 'מנהל/ת',
  'common.deceasedMark': 'ז״ל',
  'common.memorialMark': 'ז״ל',
  'common.person.unnamed': 'ללא שם',
  'common.years': '{n} שנים',
  'common.age': 'גיל {n}',
  'common.ageAtDeath': 'חי/ה {n} שנים',
  'common.showMore': 'להציג עוד {n}',

  'error.offline': 'אין חיבור. זה יישלח כשהחיבור יחזור.',
  'error.network': 'החיבור נותק לרגע. שום דבר לא אבד — אפשר לנסות שוב.',
  'error.unexpected': 'קרה משהו לא צפוי. המידע עדיין על המסך — אפשר לנסות שוב.',
  'error.storage': 'המכשיר לא הצליח לשמור את התמונה. יש לטעון מחדש את הדף ולנסות שוב — מה שכבר נשמר לא נפגע.',
  'error.notSignedIn': 'קודם צריך להתחבר.',
  'error.permission': 'אין לך הרשאה לפעולה הזאת.',
  'error.editorOnly': 'רק עורך/ת משפחה יכול/ה לעשות זאת.',
  'error.adminOnly': 'רק מנהל/ת יכול/ה לעשות זאת.',
  'error.notFound': 'לא מצאנו את זה. ייתכן שאוחד או הוסר.',

  'welcome.title': 'ברוכים הבאים למשפחת אדרי',
  'welcome.subtitle': 'מקום פרטי לאנשים שלנו, לקשרים שלנו ולסיפורים שלנו — בקולות שלנו.',
  'welcome.enterCode': 'יש לי קוד גישה משפחתי',
  'welcome.haveAccount': 'כבר יש לי חשבון',
  'welcome.haveInvite': 'קיבלתי הזמנה אישית',
  'welcome.haveTempCode': 'יש לי קוד ממנהל/ת המשפחה',
  'welcome.privacy': 'הכול כאן פרטי למשפחה בלבד.',
  'access.code.title': 'הזינו את קוד הגישה המשפחתי',
  'access.code.help': 'בן/בת משפחה שיתפו אתכם בקוד. הוא רק פותח את הדלת — עדיין תתחברו בשם שלכם.',
  'access.code.label': 'קוד גישה משפחתי',
  'access.code.submit': 'פתיחת המרחב המשפחתי',
  'access.code.invalid': 'הקוד לא מזוהה. כדאי לבדוק אותו מול מי ששלח/ה אותו.',
  'access.code.expired': 'תוקף הקוד פג. בקשו קוד חדש ממנהל/ת המשפחה.',
  'access.code.exhausted': 'הקוד נוצל יותר מדי פעמים. בקשו קוד חדש ממנהל/ת המשפחה.',
  'access.code.ok': 'הקוד התקבל. עכשיו בחרו איך להתחבר.',
  'access.invite.title': 'הזינו את קוד ההזמנה',
  'access.invite.help': 'ההזמנה האישית מחברת את החשבון למקום שלכם בעץ, כך שלא נוצרת כפילות.',
  'access.invite.label': 'קוד הזמנה',
  'access.invite.invalid': 'ההזמנה לא מזוהה.',
  'access.invite.used': 'ההזמנה כבר נוצלה. אם זה לא הייתם אתם, ספרו למנהל/ת המשפחה.',
  'access.invite.expired': 'תוקף ההזמנה פג. בקשו מהמזמין/ה לשלוח חדשה.',
  'access.invite.needDestination': 'נא להזין אימייל או מספר טלפון.',
  'access.invite.ok': 'ההזמנה התקבלה — תחוברו ל{name}.',
  'access.temp.title': 'הזינו את הקוד ממנהל/ת המשפחה',
  'access.temp.help': 'הקוד הזה מיועד רק למכשיר הזה. אחר כך אפשר לבחור קוד PIN פשוט כדי להישאר מחוברים.',
  'access.temp.label': 'קוד מכשיר',
  'access.temp.invalid': 'הקוד לא מזוהה או בוטל.',
  'access.temp.expired': 'תוקף הקוד פג. בקשו קוד חדש ממנהל/ת המשפחה.',
  'access.temp.submit': 'המשך',

  'signin.title': 'התחברות',
  'signin.subtitle': 'בחרו את הדרך שהכי נוחה לכם.',
  'signin.method.email': 'אימייל וסיסמה',
  'signin.method.link': 'שלחו לי קישור התחברות במייל',
  'signin.method.phone': 'שלחו לי קוד בהודעה',
  'signin.method.temp': 'יש לי קוד מכשיר',
  'signin.email': 'אימייל',
  'signin.password': 'סיסמה',
  'signin.submit': 'התחברות',
  'signin.createInstead': 'חדשים כאן? יצירת חשבון',
  'signin.signInInstead': 'כבר יש חשבון? התחברות',
  'signin.forgot': 'שכחתם את הסיסמה?',
  'signin.forgotHelp': 'באפליקציה האמיתית יישלח מייל לאיפוס. באב־טיפוס הזה כל סיסמה עובדת לחשבונות ההדגמה.',
  'signin.create.title': 'יצירת חשבון',
  'signin.create.name': 'השם שלך',
  'signin.create.help': 'רק אימייל וסיסמה — את השם תספרו לנו עוד רגע.',
  'signin.create.submit': 'יצירת חשבון',
  'signin.link.sent': 'שלחנו קישור התחברות אל {email}. באב־טיפוס הזה, לחצו על הכפתור למטה כדי לפתוח אותו.',
  'signin.link.open': 'פתיחת קישור ההתחברות',
  'signin.link.send': 'שלחו לי קישור',
  'signin.phone': 'מספר טלפון',
  'signin.phone.send': 'שליחת קוד',
  'signin.phone.sent': 'שלחנו קוד אל {phone}. באב־טיפוס הזה הקוד הוא {code}.',
  'signin.phone.code': 'הקוד מההודעה',
  'signin.phone.verify': 'אימות',
  'signin.demo.title': 'אב־טיפוס: התחברות כבן/בת משפחה לדוגמה',
  'signin.demo.help': 'כל סיסמה עובדת. בחרו אדם כדי לראות את האפליקציה דרך העיניים שלו.',
  'signin.demo.thisTab': 'רק בכרטיסייה הזאת (לבדיקת שני אנשים במקביל)',
  'signin.demo.button': 'להתחבר בתור {name}',
  'auth.invalidCredentials': 'לא זיהינו את האימייל והסיסמה.',
  'auth.noMembership': 'החשבון הזה עדיין לא שייך למשפחה.',
  'auth.invalidEmail': 'נא להזין כתובת אימייל תקינה.',
  'auth.invalidPhone': 'נא להזין מספר טלפון תקין.',
  'auth.invalidCode': 'הקוד לא נכון.',
  'auth.weakPassword': 'נא לבחור סיסמה של 4 תווים לפחות.',
  'auth.emailExists': 'כבר קיים חשבון עם האימייל הזה. נסו להתחבר במקום.',
  'auth.needAccessCode': 'קודם יש להזין קוד גישה משפחתי או הזמנה.',

  'pin.setTitle': 'בחרו קוד PIN למכשיר הזה',
  'pin.setHelp': 'קוד PIN של 4 ספרות מאפשר לפתוח את האפליקציה במהירות במכשיר הזה. זו לא סיסמה והוא עובד רק כאן.',
  'pin.unlockTitle': 'ברוכים השבים, {name}',
  'pin.unlockHelp': 'הזינו את הקוד כדי להמשיך.',
  'pin.label': 'קוד PIN',
  'pin.confirmLabel': 'הזינו את הקוד שוב',
  'pin.mismatch': 'שני הקודים לא זהים.',
  'pin.invalid': 'נא להשתמש ב-4 עד 6 ספרות.',
  'pin.wrong': 'הקוד לא נכון. נסו שוב — שום דבר לא אבד.',
  'pin.noSession': 'המכשיר הזה לא מחובר. בקשו קוד חדש ממנהל/ת המשפחה.',
  'pin.unlock': 'פתיחה',
  'pin.skip': 'לדלג בינתיים',
  'pin.forgot': 'שכחתם את הקוד? מנהל/ת המשפחה יכול/ה לתת קוד מכשיר חדש.',
  'pin.lockNow': 'נעילת המכשיר',
  'recovery.banner': 'אתם מחוברים במכשיר הזה בלבד. הוסיפו אימייל כדי שתוכלו להיכנס גם ממכשיר אחר.',
  'recovery.add': 'הוספת אימייל',
  'recovery.later': 'אחר כך',
  'recovery.title': 'הוספת דרך לחזור פנימה',
  'recovery.help': 'הוספת אימייל לא משנה כלום — המקום שלכם בעץ, הסיפורים וההרשאות נשארים אותו דבר.',
  'recovery.done': 'בוצע. {email} מקושר עכשיו לחשבון שלכם.',

  'onb.step': 'שלב {n} מתוך {total}',
  'onb.lang.title': 'איזו שפה נוחה לכם?',
  'onb.lang.help': 'אפשר להחליף בכל רגע, מכל מסך.',
  'onb.name.title': 'מה שמכם?',
  'onb.name.given': 'שם פרטי',
  'onb.name.family': 'שם משפחה',
  'onb.name.nickname': 'כינוי',
  'onb.name.nicknameHint': 'איך קוראים לך במשפחה',
  'onb.name.previewHe': 'בעברית השם שלך יופיע כ',
  'onb.name.previewEn': 'באנגלית השם שלך יופיע כ',
  'onb.name.fix': 'לשנות',
  'onb.name.previewHelp': 'קרובים שמשתמשים באפליקציה בשפה השנייה יראו את זה. זה רק ניחוש — תקנו את האיות אם הוא נראה שגוי.',
  'onb.birth.title': 'מתי נולדתם?',
  'onb.birth.help': 'מספיקה שנה. זה עוזר לנו למקם אתכם בעץ.',
  'onb.birth.year': 'שנת לידה',
  'onb.birth.pick': 'בחירת שנה',
  'onb.birth.ratherNot': 'מעדיפ/ה לא לציין',
  'onb.inTree.title': 'האם אתם כבר בעץ המשפחה?',
  'onb.inTree.help': 'ייתכן שמישהו הוסיף אתכם לפני שהצטרפתם.',
  'onb.inTree.yes': 'כן, נדמה לי',
  'onb.inTree.no': 'לא, אני חדש/ה בעץ',
  'onb.inTree.notSure': 'לא בטוח/ה',
  'onb.match.title': 'זה את/ה?',
  'onb.match.help': 'מצאנו אנשים עם שם דומה. בחרו את עצמכם, או ספרו לנו שאתם לא ברשימה.',
  'onb.match.none': 'אף אחד מאלה הוא לא אני',
  'onb.match.likely': 'נראה כמו התאמה',
  'onb.match.allClaimed': 'לכל מי שבעץ כבר יש חשבון. בחרו ״אף אחד מאלה הוא לא אני״ כדי להוסיף את עצמכם.',
  'onb.match.thisIsMe': 'זה אני',
  'onb.match.invited': 'ההזמנה שלכם מחברת אתכם ל{name}.',
  'onb.relation.title': 'איך אתם קשורים?',
  'onb.relation.help': 'ספרו לנו על אדם אחד שאתם קשורים אליו. עורך/ת יוכל/תוכל להוסיף עוד אחר כך.',
  'onb.relation.iAm': 'אני',
  'onb.relation.of': 'של',
  'onb.relation.child': 'ילד/ה',
  'onb.relation.parent': 'הורה',
  'onb.relation.partner': 'בן/בת זוג',
  'onb.relation.sibling': 'אח/ות',
  'onb.relation.pick': 'בחירת בן/בת משפחה',
  'onb.review.title': 'מוכנים להיכנס לעץ',
  'onb.review.name': 'שם',
  'onb.review.birth': 'לידה',
  'onb.review.connection': 'קשר',
  'onb.review.claim': 'תחוברו ל{name}',
  'onb.review.new': 'תתווספו בתור {relation} של {name}',
  'onb.review.newNoRel': 'תתווספו כאדם חדש. עורך/ת יוכל/תוכל לחבר אתכם אחר כך.',
  'onb.review.reviewNote': 'קשרים משפחתיים שמוסיפים חברי משפחה נבדקים על ידי עורך/ת משפחה לפני שכולם רואים אותם.',
  'onb.enter': 'כניסה לעץ המשפחה',
  'onb.claimPending': 'הבקשה שלכם לחיבור נשלחה לעורך/ת משפחה. בינתיים אפשר לסייר בעץ.',

  'tree.title': 'עץ המשפחה',
  'tree.centerMe': 'מרכוז עליי',
  'tree.myBranch': 'הענף שלי',
  'tree.myBranch.help': 'מציג אתכם, ההורים, בני/בנות הזוג, האחים והצאצאים שלכם.',
  'tree.branchOf': 'הענף של {name}',
  'tree.entireFamily': 'כל המשפחה',
  'tree.find': 'חיפוש אדם',
  'tree.filters': 'סינון',
  'tree.editFamily': 'עריכת המשפחה',
  'tree.editFamily.on': 'במצב עריכה — הקישו על אדם כדי להוסיף קרוב/ה',
  'tree.zoomIn': 'הגדלה',
  'tree.zoomOut': 'הקטנה',
  'tree.zoomReset': 'איפוס תצוגה',
  'tree.listView': 'תצוגת רשימה',
  'tree.mapView': 'תצוגת עץ',
  'tree.noMe': 'עדיין לא חוברתם לאדם בעץ.',
  'tree.noMe.action': 'למצוא את עצמי',
  'tree.legend': 'איך לקרוא את העץ',
  'tree.legend.parent': 'הורה – ילד/ה',
  'tree.legend.partner': 'בני זוג',
  'tree.legend.former': 'בני זוג לשעבר',
  'tree.legend.other': 'אימוץ, חורג/ת או אפוטרופוס',
  'tree.legend.pending': 'ממתין לבדיקה',
  'tree.legend.memory': 'סיפורים ותמונות חדשים (גדול יותר = חדש יותר)',
  'tree.legend.you': 'טבעת טורקיז — זה את/ה',
  'tree.legend.dim': 'דהוי — מחוץ לענף או לסינון',
  'tree.people': '{n} אנשים מוצגים',
  'tree.dimmed': '{n} מעומעמים בגלל הסינון',
  'tree.hidden': '{n} מוסתרים בגלל הסינון',
  'tree.pendingMarker': 'ממתין לבדיקה',
  'tree.newStory': 'סיפור חדש',
  'tree.stories': '{n} סיפורים',
  'tree.hint': 'גררו כדי להזיז · צבטו או גללו כדי להגדיל · הקישו על אדם כדי לפתוח',
  'tree.keyboardHint': 'Tab למעבר בין אנשים, Enter לפתיחה, חצים להזזה, + ו-− להגדלה.',
  'tree.generation': 'דור {n}',
  'tree.list.title': 'האנשים בתצוגה',
  'tree.list.help': 'אותם אנשים ואותם קשרים כמו בעץ, כרשימה.',
  'tree.list.parents': 'הורים',
  'tree.list.partners': 'בני/בנות זוג',
  'tree.list.children': 'ילדים',
  'tree.list.siblings': 'אחים ואחיות',
  'tree.notInBranch': 'לא בענף הנוכחי',
  'tree.card.viewProfile': 'לפרופיל',
  'tree.card.pending': 'האדם הזה ממתין לבדיקה של עורך/ת משפחה.',
  'tree.card.you': 'זה את/ה',
  'tree.card.latest': 'אחרונים',
  'portrait.add': 'הוספת תמונה',
  'portrait.change': 'החלפת תמונה',
  'portrait.saved': 'התמונה נשמרה. כל התמונות נשמרות — שום דבר לא הולך לאיבוד.',
  'portrait.failed': 'לא הצלחנו לקרוא את התמונה. נסו תמונה אחרת.',
  'portrait.ownedByOther': 'רק מי שהעיגול הזה שייך לו יכול לשנות את התמונה.',
  'portrait.unclaimed': 'אף אחד עדיין לא תבע את העיגול הזה — כל בן משפחה יכול להוסיף תמונה.',
  'portrait.yours': 'העיגול הזה שלך — רק את/ה יכול/ה לשנות את התמונות שלו.',
  'portrait.managed': 'את/ה מנהל/ת את הפרופיל הזה, ולכן יכול/ה לשנות את התמונות.',
  'portrait.adminEdit': 'העיגול הזה שייך לבעליו. כמנהל/ת אפשר לשנות את התמונה ואת הפרטים שלו דרך „עריכת פרטים”.',
  'portrait.owned': 'העיגול הזה שייך לבעליו; רק הם יכולים לשנות את התמונות.',
  'portrait.gallery': 'תמונות של האדם הזה',
  'portrait.current': 'מוצג בעץ',
  'portrait.use': 'להציג את התמונה הזו בעץ',
  'portrait.addedWhen': 'נוסף {when}',
  'portrait.take': 'צילום תמונה',
  'portrait.choose': 'בחירת תמונה',
  'portrait.camera.title': 'צילום תמונה',
  'portrait.camera.help': 'מרכזו את הפנים במסגרת ולחצו על הכפתור.',
  'portrait.camera.snap': 'צלם/י',
  'portrait.camera.retake': 'לצלם שוב',
  'portrait.camera.use': 'להשתמש בתמונה הזו',
  'portrait.camera.denied': 'לא הצלחנו לפתוח את המצלמה. בדקו שהדפדפן מורשה להשתמש בה, או בחרו תמונה במקום.',
  'portrait.camera.unsupported': 'הדפדפן הזה לא יכול להשתמש במצלמה כאן. בחרו תמונה במקום.',
  'tree.showEntireFamily': 'להציג את כל המשפחה',
  'tree.lost': 'חזרה למשפחה',
  'tree.star': 'כוכב — לעקוב מקרוב אחרי האדם הזה',
  'tree.unstar': 'הסרת הכוכב',
  'tree.legend.star': 'טבעת זהב — מישהו שסימנתם בכוכב',
  'tree.legend.size': 'עיגול גדול יותר — קרה משהו חדש לאחרונה',
  'tree.badge.story': 'סיפור',
  'tree.badge.photo': 'תמונה חדשה',
  'tree.badge.more': 'עוד {n}',
  'tree.meUnconnected': 'עדיין לא חוברת לעץ — הוסיפו קרוב משפחה',
  'tree.card.myProfile': 'הפרופיל שלי',
  'tree.lock.locked': 'העיגול הזה נעול. רק מנהל/ת יכול/ה לשנות את הפרטים שלו.',
  'tree.lock.lockedAdmin': 'נעול — רק מנהלים יכולים לערוך אותו. הקשה לפתיחת הנעילה.',
  'tree.lock.open': 'העיגול הזה לא נעול — שינויים נכנסים מיד.',
  'tree.lock.openAdmin': 'לא נעול — שינויים נכנסים מיד. הקישו כדי לנעול.',
  'tree.lock.owned': 'העיגול הזה שייך לבעליו. השינויים שלכם הופכים להצעות למנהל.',
  'tree.lock.nowLocked': 'ננעל. מעכשיו שינויים באדם הזה הם הצעות.',
  'tree.lock.nowOpen': 'נפתח. שינויים באדם הזה נכנסים מיד.',

  'find.title': 'חיפוש אדם',
  'find.placeholder': 'שם בעברית או באנגלית, כינוי…',
  'find.noResults': 'אף אחד לא מתאים ל"{q}". נסו איות אחר או כינוי.',
  'find.reason.nickname': 'כינוי',
  'find.reason.previous': 'שם קודם',
  'find.reason.hebrew': 'שם בעברית',
  'find.reason.english': 'שם באנגלית',
  'find.reason.name': 'שם',
  'filters.title': 'סינון',
  'filters.age': 'גיל',
  'filters.ageFrom': 'מגיל',
  'filters.ageTo': 'עד גיל',
  'filters.ageHelp': 'גיל היום לאנשים בחיים, גיל בפטירה לאחרים.',
  'filters.ageOn': 'להציג אנשים סביב גיל מסוים',
  'filters.ageAround': 'סביב גיל {n}',
  'filters.ageRange': 'גילאים {from} עד {to}',
  'filters.ageSpan': 'כמה קרוב',
  'filters.ageSpan.n': '± {n} שנים',
  'filters.status': 'להציג',
  'filters.status.all': 'את כולם',
  'filters.status.living': 'בחיים',
  'filters.status.deceased': 'נפטרו',
  'filters.withStories': 'רק אנשים עם סיפורים',
  'filters.mode': 'אנשים שלא מתאימים',
  'filters.mode.dim': 'לעמעם אותם (הקשרים נשארים גלויים)',
  'filters.mode.hide': 'להציג רק התאמות',
  'filters.reset': 'ניקוי הסינון',
  'filters.apply': 'החלה',
  'filters.active': '{n} מסננים פעילים',

  'profile.title': 'פרופיל',
  'profile.myTitle': 'הפרופיל שלי',
  'profile.myAccount': 'חשבון, מכשירים ויציאה',
  'profile.names': 'שמות',
  'profile.name.en': 'שם באנגלית',
  'profile.name.he': 'שם בעברית',
  'profile.name.nickname': 'כינוי',
  'profile.name.previous': 'שמות קודמים',
  'profile.name.given': 'שם פרטי',
  'profile.name.middle': 'שם אמצעי',
  'profile.name.family': 'שם משפחה',
  'profile.name.missing': 'לא נרשם שם ב{lang}',
  'profile.born': 'לידה',
  'profile.died': 'פטירה',
  'profile.birthPlace': 'מקום לידה',
  'profile.status': 'מצב',
  'profile.gender': 'מגדר',
  'profile.family': 'משפחה',
  'profile.parents': 'הורים',
  'profile.partners': 'בני/בנות זוג',
  'profile.children': 'ילדים',
  'profile.siblings': 'אחים ואחיות',
  'profile.grandparents': 'סבים וסבתות',
  'profile.grandchildren': 'נכדים',
  'profile.stories': 'סיפורים',
  'profile.storiesEmpty': 'עדיין אין סיפורים עם {name}. היו הראשונים להקליט.',
  'profile.events': 'אירועי חיים',
  'profile.managers': 'מי יכול לנהל את הפרופיל',
  'profile.managersHelp': 'גלוי לעורכים ולאנשים המעורבים.',
  'profile.claimedBy': 'מחובר/ת בתור האדם הזה: {name}',
  'profile.notClaimed': 'אין חשבון מקושר לאדם הזה.',
  'profile.helper': '{name} (עוזר/ת)',
  'profile.history': 'היסטוריית שינויים',
  'profile.historyHelp': 'גלוי לעורכים ולמנהלים.',
  'profile.edit': 'עריכת פרטים',
  'profile.editShort': 'עריכה',
  'profile.suggest': 'הצעת תיקון',
  'profile.addRelative': 'הוספת קרוב/ה',
  'profile.recordFor': 'הקלטת סיפור עבור {name}',
  'profile.hearStories': 'לשמוע סיפורים',
  'profile.locked': 'חלק מהפרטים נעולים על ידי מנהל/ת: {reason}',
  'profile.lockedShort': 'נעול',
  'profile.pendingChange': 'שינוי שהצעתם ממתין לבדיקה.',
  'profile.relationToYou': '{relation}',
  'profile.thisIsYou': 'זה את/ה',
  'profile.notes': 'הערות',
  'profile.merged': 'הרשומה הזאת אוחדה לתוך אדם אחר.',
  'profile.viewMerged': 'פתיחת הרשומה הנוכחית',
  'profile.subtype.biological': 'ביולוגי',
  'profile.subtype.adoptive': 'אימוץ',
  'profile.subtype.step': 'חורג/ת',
  'profile.subtype.guardian': 'אפוטרופוס',
  'profile.subtype.foster': 'אומנה',
  'profile.subtype.unspecified': '',
  'profile.subtype.married': 'נשואים',
  'profile.subtype.partnered': 'בני זוג',
  'profile.subtype.former': 'לשעבר',
  'profile.myDrafts': 'ההקלטות הלא גמורות שלך',
  'profile.myRequests': 'ההצעות שלך',
  'profile.myDevices': 'המכשירים שלך',
  'profile.signOut': 'התנתקות',
  'profile.signOutWarn': 'יש לך {n} הקלטות שעדיין לא גובו. אם תתנתקו עכשיו הן יישארו במכשיר הזה אבל לא יעלו עד שתתחברו שוב כאן.',
  'profile.signOutAnyway': 'להתנתק בכל זאת',
  'profile.helping': 'את/ה עוזר/ת לנהל את',

  'edit.title': 'עריכת {name}',
  'edit.suggestTitle': 'הצעת תיקון עבור {name}',
  'edit.reviewNote': 'מכיוון שזה משנה פרט חשוב על מישהו אחר, עורך/ת משפחה יבדוק/תבדוק לפני שזה יופיע.',
  'edit.directNote': 'השינויים נשמרים ישירות ונרשמים בהיסטוריית השינויים.',
  'edit.lockedNote': 'העיגול הזה נעול על ידי מנהל. השינויים שלכם נשלחים כהצעה; לאחר אישור הם יופיעו בעץ.',
  'edit.ownedNote': 'העיגול הזה שייך למישהו אחר. השינויים שלכם נשלחים כהצעה לאישור מנהל.',
  'edit.lockedOnlyAdmin': 'העיגול הזה נעול על ידי מנהל/ת. רק מנהלים יכולים לשנות את הפרטים שלו.',
  'edit.portrait.changeHelp': 'הקשה על המצלמה כדי לצלם או לבחור תמונה מהמכשיר. היא תהיה התמונה שמוצגת בעץ.',
  'edit.reason': 'למה השינוי נדרש?',
  'edit.reasonHelp': 'עוזר לעורך/ת להבין — למשל "בדרכון שלה כתוב 1932".',
  'edit.presence': '{name} עורך/ת את האדם הזה כרגע.',
  'edit.presenceMany': '{names} עורכים את האדם הזה כרגע.',
  'edit.save': 'שמירת השינויים',
  'edit.send': 'שליחה לבדיקה',
  'edit.sent': 'נשלח לעורך/ת משפחה. נודיע לכם כשייבדק.',
  'edit.saved': 'נשמר.',
  'edit.savedMerged': 'נשמר. מישהו אחר שינה פרטים אחרים באותו זמן — שני השינויים נשמרו.',
  'edit.queued': 'נשמר במכשיר הזה. יישלח כשהחיבור יחזור.',
  'edit.noChanges': 'שום דבר לא השתנה.',
  'edit.deathDate': 'תאריך פטירה',
  'edit.livingQuestion': 'האם {name} בחיים?',
  'edit.portrait': 'תמונה',
  'edit.portrait.change': 'בחירת תמונה',
  'edit.portrait.remove': 'הסרת תמונה',
  'edit.portrait.help': 'באב־טיפוס התמונות נשארות במכשיר הזה.',
  'person.sentForReview': 'נשלח לבדיקה.',
  'person.locked': 'הפרטים האלה נעולים על ידי מנהל/ת. עדיין אפשר להציע תיקון.',
  'person.error.nameRequired': 'נא להזין לפחות שם פרטי.',

  'conflict.title': 'מישהו שינה את זה בזמן שערכתם',
  'conflict.body': '{name} שינה/תה את המידע הזה {when}. שום דבר לא אבד. בחרו איזה מידע נכון.',
  'conflict.current': 'המידע הנוכחי',
  'conflict.yours': 'המידע שלך',
  'conflict.keepCurrent': 'להשאיר את הנוכחי',
  'conflict.useMine': 'להשתמש בשלי',
  'conflict.askEditor': 'לשאול עורך/ת',
  'conflict.askEditorHelp': 'שולח את שתי הגרסאות לעורך/ת משפחה להכרעה.',
  'conflict.escalated': 'שתי הגרסאות נשלחו לעורך/ת משפחה.',
  'conflict.applyChoices': 'שמירת הבחירות שלי',
  'conflict.field': 'שדה',
  'conflict.offlineTitle': 'שינוי שנשמר צריך את ההחלטה שלך',
  'conflict.offlineBody': 'בזמן שלא היה חיבור, {name} שינה/תה את {field}. בחרו מה להשאיר.',

  'add.step.who': 'את מי מוסיפים?',
  'add.step.how': 'מה הקשר?',
  'add.step.more': 'עוד כמה פרטים (לא חובה)',
  'add.useExisting': 'כבר בעץ? לחפש אותו',
  'add.useNew': 'להוסיף מישהו חדש במקום',
  'add.alsoChildOfBlank': 'גם ילד/ה של',
  'add.relationLabel': 'הוא/היא ה… של {name}',
  'add.relationLabelBlank': 'הוא/היא ה…',
  'add.needRelatedTo': 'בחרו למי הם קשורים.',
  'add.thisPerson': 'האדם הזה',
  'add.needName': 'כתבו את השם כדי להוסיף.',
  'add.needRelation': 'בחרו מה הקשר.',
  'add.inviteWarnTitle': 'תישלח אליהם הודעה במייל',
  'add.inviteWarnBody': 'ברגע שתלחצו על הכפתור למטה, הזמנה תישלח אל {email} והם יוכלו להיכנס למשפחה מיד. מחקו את השדה אם אתם מעדיפים להוסיף בשקט.',
  'add.parent': 'הורה',
  'add.partner': 'בן/בת זוג',
  'add.child': 'ילד/ה',
  'add.sibling': 'אח/ות',
  'add.pickExisting': 'בחירת אדם קיים',
  'add.subtype.parent': 'סוג ההורות (לא חובה)',
  'add.subtype.partner': 'סוג הזוגיות (לא חובה)',
  'add.partnerCurrent': 'בני זוג כיום',
  'add.partnerFormer': 'בני זוג לשעבר',
  'add.partnerStart': 'יחד מאז',
  'add.partnerEnd': 'עד',
  'add.alsoChildOf': 'גם ילד/ה של {name}?',
  'add.sharedParents': 'אילו הורים משותפים להם?',
  'add.dupTitle': 'ייתכן שזה כבר אותו אדם',
  'add.dupBody': 'מצאנו מישהו דומה שכבר בעץ. רוצים לבדוק את האדם הקיים במקום ליצור כפילות?',
  'add.dupReview': 'להשתמש ב{name}',
  'add.dupIgnore': 'לא, זה אדם אחר',
  'add.dupReason.name': 'שם דומה',
  'add.dupReason.birth': 'שנת לידה דומה',
  'add.dupReason.connected': 'כבר מקושר/ת ל{name}',
  'add.previewSentence.parent': '{new} יהיה/תהיה הורה של {anchor}.',
  'add.previewSentence.child': '{new} יהיה/תהיה ילד/ה של {anchor}.',
  'add.previewSentence.partner': '{new} ו{anchor} יהיו בני זוג.',
  'add.previewSentence.sibling': '{new} יהיה/תהיה אח/ות של {anchor}, עם הורים משותפים: {parents}.',
  'add.previewSentence.coParent': '{new} יהיה/תהיה גם ילד/ה של {names}.',
  'add.submit': 'הוספה למשפחה',
  'add.submitReview': 'שליחה לעורך/ת משפחה',
  'add.done': '{name} נוסף/ה.',
  'add.note': 'הערה לעורך/ת (לא חובה)',
  'rel.error.self': 'אדם לא יכול להיות קרוב של עצמו.',
  'rel.error.cycle': 'זה יהפוך מישהו לאב קדמון של עצמו. בדקו את האנשים שנבחרו.',
  'rel.error.exists': 'הקשר הזה כבר קיים.',
  'rel.error.tooManyParents': 'לאדם הזה כבר רשומים כמה הורים. כדאי לבדוק עם עורך/ת.',
  'rel.error.duplicate': 'זה נראה כמו אותו אדם כמו {name}. בדקו לפני ההוספה.',
  'rel.error.noPerson': 'נא לבחור או להוסיף אדם.',
  'rel.error.siblingNeedsParent': 'כדי להוסיף אח/ות, ל{name} צריך להיות לפחות הורה אחד בעץ. הוסיפו קודם את ההורה.',
  'rel.error.editorOnly': 'רק עורך/ת משפחה יכול/ה לשנות את זה ישירות. אפשר להציע את השינוי במקום.',
  'rel.locked': 'הקשר הזה נעול על ידי מנהל/ת.',


  'stories.title': 'סיפורים',
  'photos.title': 'תמונות',
  'photos.subtitle': 'מה קורה במשפחה — תמונה מהיום, מפגש, והאירועים שמתקרבים.',
  'photos.add': 'שיתוף תמונה',
  'photos.addTitle': 'שיתוף תמונה',
  'photos.addEvent': 'הוספת אירוע',
  'photos.addEventTitle': 'הוספת אירוע',
  'photos.eventTitle': 'מה האירוע?',
  'photos.eventTitleHint': 'בת המצווה של נועה, פסח אצל סבתא…',
  'photos.eventNotes': 'פרטים',
  'photos.eventNotesHint': 'איפה, באיזו שעה, מי מארח',
  'photos.eventWhen': 'מתי?',
  'photos.eventPicture': 'הוספת תמונה (לא חובה)',
  'photos.needPictureOrEvent': 'הוסיפו תמונה, או תנו לאירוע שם.',
  'photos.editDetails': 'עריכת פרטים',
  'photos.react': 'תגובה באימוג׳י',
  'tree.card.openStory': 'לפתוח את הסיפור',
  'tree.card.storyPeekHelp': 'פתחו את הסיפור כדי להאזין, לקרוא את התמלול, או להוסיף זיכרון משלכם.',
  'photos.detailsSaved': 'הפרטים נשמרו.',
  'photos.inPhoto': 'בתמונה הזו',
  'photos.nobodyPinned': 'עדיין לא סומן אף אחד בתמונה הזו.',
  'photos.pinMe': 'אני בתמונה הזו',
  'photos.tagSomeone': 'לתייג אנשים בתמונה',
  'photos.tagTitle': 'מי בתמונה הזו?',
  'photos.tagEmpty': 'עדיין אף אחד — הוסיפו את עצמכם, או התחילו להקליד שם.',
  'photos.pinSomeone': 'לסמן מישהו שנמצא בתמונה',
  'photos.pinSomeoneHint': 'התחילו להקליד שם',
  'photos.unpin': 'להסיר את {name} מהתמונה',
  'photos.share': 'לשתף עם המשפחה',
  'photos.caption': 'כיתוב',
  'photos.captionHint': 'מי, איפה, מה קרה',
  'photos.isEvent': 'התמונה הזו היא אירוע',
  'photos.isEventHelp': 'חתונה, לידה, מפגש משפחתי — משהו שהמשפחה מציינת. אירועים מקבלים סימון מיוחד, ובהמשך האפליקציה תוכל להזכיר לכולם כשאירוע מתקרב.',
  'photos.when': 'מתי זה היה?',
  'photos.eventMark': 'אירוע',
  'photos.empty': 'עדיין אין תמונות. שתפו את הראשונה.',
  'photos.emptyEvents': 'עדיין אין תמונות אירוע. סמנו תמונה כאירוע כשמשתפים אותה.',
  'photos.saved': 'התמונה שותפה עם המשפחה.',
  'photos.savedEvent': 'האירוע שותף עם המשפחה.',
  'photos.sharedBy': 'שותף על ידי {name} · {when}',
  'stories.subtitle': 'זיכרונות משפחתיים בקולות של האנשים שחיו אותם.',
  'stories.empty': 'אין סיפורים מתאימים. נסו לנקות את הסינון — או הקליטו את הראשון.',
  'stories.emptyFirst': 'עדיין אין סיפורים. הקליטו את הראשון — זיכרון, רגע, אדם.',
  'stories.emptyFiltered': 'אין התאמות. נקו את החיפוש או הסינון כדי לראות את כל הסיפורים.',
  'stories.searchShort': 'חיפוש סיפורים',
  'stories.inStory': 'בסיפור הזה: {names}',
  'stories.order.timeline': 'לפי תאריך',
  'timeline.born': '{name} נולד/ה',
  'timeline.born.m': '{name} נולד',
  'timeline.born.f': '{name} נולדה',
  'stories.order.latest': 'אחרונים',
  'stories.updated': 'עודכן {when}',
  'stories.draft.unfinished': 'הקלטה לא גמורה',
  'stories.filter.all': 'כל הסיפורים',
  'stories.filter.person': 'על',
  'stories.filter.storyteller': 'מספר/ת',
  'stories.filter.branch': 'רק הענף שלי',
  'stories.filter.from': 'משנה',
  'stories.filter.to': 'עד שנה',
  'stories.filter.place': 'מקום',
  'stories.filter.type': 'סוג',
  'stories.filter.type.audio': 'הקלטות',
  'stories.filter.type.text': 'כתובים',
  'stories.search': 'חיפוש בכותרות ובתמלילים',
  'stories.approxGroup': 'משוער',
  'stories.approxOrder': 'הסדר בתוך התקופה הזאת משוער',
  'stories.drafts': 'ההקלטות הלא גמורות שלך',
  'stories.draft.resume': 'להמשיך',
  'stories.draft.delete': 'מחיקת הטיוטה',
  'stories.draft.deleteConfirm': 'למחוק את הטיוטה ואת ההקלטה מהמכשיר הזה? אי אפשר לבטל.',
  'stories.draft.recordedFor': 'עבור {name}',
  'stories.uploads': 'העלאות',
  'story.untitled': 'סיפור ללא כותרת',
  'story.titlePending': 'כותרת תתווסף',
  'story.toldBy': 'מספר/ת: {name}',
  'story.attribution': 'דיבר/ה: {speaker} • העלה/תה: {uploader}',
  'story.contributors': 'עם זיכרונות של {names}',
  'story.people': 'האנשים בסיפור',
  'story.inThis': 'בסיפור הזה',
  'story.event': 'סביב',
  'story.spokenByLabel': 'מדבר/ת',
  'story.uploadedByLabel': 'העלה/תה',
  'photos.sharedByLabel': 'שיתף/ה',
  'story.place': 'מקום',
  'story.when': 'מתי',
  'story.approximate': 'משוער',
  'story.contribution': 'הקלטה אחת',
  'story.playAll': 'לנגן הכול לפי הסדר',
  'story.playStory': 'להשמיע את הסיפור',
  'story.differentDate': '{name} זוכר/ת שזה היה ב{date}',
  'story.transcript': 'תמליל',
  'story.transcript.pending': 'התמליל בהכנה…',
  'story.transcript.processing': 'התמליל בהכנה…',
  'story.transcript.failed': 'לא הצלחנו להכין תמליל אוטומטית. עורך/ת יכול/ה לנסות שוב.',
  'story.transcript.unavailable': 'עדיין אין תמליל.',
  'story.transcript.empty': 'התמליל יופיע כאן אחרי שההקלטה תעובד.',
  'story.transcript.ai': 'הוכן אוטומטית — ייתכנו טעויות.',
  'story.transcript.corrected': 'תוקן על ידי אדם.',
  'story.transcript.correct': 'תיקון התמליל',
  'story.transcript.translationNote': 'זהו תרגום.',
  'story.edit': '\u05e2\u05e8\u05d9\u05db\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8',
  'story.editAsAdmin': '\u05e2\u05e8\u05d9\u05db\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8 (\u05de\u05e0\u05d4\u05dc/\u05ea)',
  'story.belongsTo': '{name} \u05d4\u05e7\u05dc\u05d9\u05d8/\u05d4 \u05d0\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8, \u05d0\u05d6 \u05e9\u05d9\u05e0\u05d5\u05d9\u05d9\u05dd \u05e2\u05d5\u05d1\u05e8\u05d9\u05dd \u05d0\u05dc\u05d9\u05d5/\u05d4 \u05e7\u05d5\u05d3\u05dd.',
  'story.delete': '\u05de\u05d7\u05d9\u05e7\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8',
  'story.deleteConfirm': '\u05dc\u05de\u05d7\u05d5\u05e7 \u05d0\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8? \u05d2\u05dd \u05d4\u05d4\u05e7\u05dc\u05d8\u05d5\u05ea \u05d9\u05d9\u05de\u05d7\u05e7\u05d5. \u05de\u05e0\u05d4\u05dc/\u05ea \u05d9\u05db\u05d5\u05dc/\u05d4 \u05dc\u05e9\u05d7\u05d6\u05e8.',
  'story.suggest': '\u05d4\u05e6\u05e2\u05ea \u05e9\u05d9\u05e0\u05d5\u05d9',
  'story.suggest.help': '\u05e9\u05e0\u05d5 \u05de\u05d4 \u05e9\u05e0\u05e8\u05d0\u05d4 \u05dc\u05d0 \u05e0\u05db\u05d5\u05df \u05d5\u05e9\u05dc\u05d7\u05d5 \u05dc\u05de\u05d9 \u05e9\u05d4\u05e7\u05dc\u05d9\u05d8/\u05d4 \u05d0\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8. \u05e9\u05d5\u05dd \u05d3\u05d1\u05e8 \u05dc\u05d0 \u05de\u05e9\u05ea\u05e0\u05d4 \u05e2\u05d3 \u05e9\u05d9\u05d0\u05e9\u05e8/\u05ea.',
  'story.suggest.note': '\u05de\u05e9\u05d4\u05d5 \u05e9\u05ea\u05e8\u05e6\u05d5 \u05dc\u05d4\u05d5\u05e1\u05d9\u05e3',
  'story.suggest.notePlaceholder': '\u05e1\u05d1\u05ea\u05d0 \u05ea\u05de\u05d9\u05d3 \u05d0\u05de\u05e8\u05d4 \u05e9\u05d6\u05d4 \u05d4\u05d9\u05d4 \u05e9\u05e0\u05d4 \u05d0\u05d7\u05e8\u05d9\u2026',
  'story.suggest.summary': '\u05d0\u05ea\u05dd \u05de\u05e6\u05d9\u05e2\u05d9\u05dd: {what}',
  'story.suggest.send': '\u05e9\u05dc\u05d9\u05d7\u05ea \u05d4\u05d4\u05e6\u05e2\u05d4',
  'story.suggest.sentToast': '\u05e0\u05e9\u05dc\u05d7 \u05d0\u05dc {name}.',
  'story.suggest.waiting': '{n} \u05de\u05de\u05ea\u05d9\u05e0\u05d5\u05ea \u05dc\u05db\u05dd',
  'story.suggest.waitingHelp': '\u05de\u05d9\u05e9\u05d4\u05d5 \u05d1\u05de\u05e9\u05e4\u05d7\u05d4 \u05d7\u05d5\u05e9\u05d1 \u05e9\u05e6\u05e8\u05d9\u05da \u05dc\u05e9\u05e0\u05d5\u05ea \u05db\u05d0\u05df. \u05e9\u05d5\u05dd \u05d3\u05d1\u05e8 \u05dc\u05d0 \u05e7\u05d5\u05e8\u05d4 \u05e2\u05d3 \u05e9\u05ea\u05d0\u05e9\u05e8\u05d5.',
  'story.suggest.yours': '\u05de\u05d4 \u05e9\u05d4\u05e6\u05e2\u05ea\u05dd',
  'story.suggest.from': '\u05de\u05d0\u05ea {name}',
  'story.suggest.sent': '\u05de\u05d7\u05db\u05d4 \u05dc\u05ea\u05e9\u05d5\u05d1\u05d4',
  'story.suggest.accept': '\u05db\u05df, \u05dc\u05e9\u05e0\u05d5\u05ea',
  'story.suggest.decline': '\u05dc\u05d0, \u05dc\u05d4\u05e9\u05d0\u05d9\u05e8',
  'story.suggest.withdraw': '\u05dc\u05d1\u05d8\u05dc \u05d0\u05ea \u05d4\u05d4\u05e6\u05e2\u05d4',
  'story.suggest.accepted': '\u05e9\u05d5\u05e0\u05d4.',
  'story.suggest.declined': '\u05e0\u05e9\u05d0\u05e8 \u05db\u05e4\u05d9 \u05e9\u05d4\u05d9\u05d4.',
  'story.suggest.withdrawn': '\u05d1\u05d5\u05d8\u05dc.',
  'story.change.title': '\u05dc\u05e7\u05e8\u05d5\u05d0 \u05dc\u05d6\u05d4 \u201C{title}\u201D',
  'story.change.date': '\u05dc\u05e8\u05e9\u05d5\u05dd \u05e9\u05d6\u05d4 \u05e7\u05e8\u05d4 {date}',
  'story.change.people': '\u05d4\u05d0\u05e0\u05e9\u05d9\u05dd \u05d1\u05e1\u05d9\u05e4\u05d5\u05e8: {names}',
  'story.error.suggestInstead': '\u05e8\u05e7 \u05de\u05d9 \u05e9\u05d4\u05e7\u05dc\u05d9\u05d8/\u05d4 \u05d0\u05ea \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8 \u05d9\u05db\u05d5\u05dc/\u05d4 \u05dc\u05e9\u05e0\u05d5\u05ea \u05d0\u05d5\u05ea\u05d5. \u05d0\u05e4\u05e9\u05e8 \u05dc\u05d4\u05e6\u05d9\u05e2 \u05e9\u05d9\u05e0\u05d5\u05d9.',
  'story.error.editDirectly': '\u05d6\u05d4 \u05d4\u05e1\u05d9\u05e4\u05d5\u05e8 \u05e9\u05dc\u05db\u05dd \u2014 \u05d0\u05e4\u05e9\u05e8 \u05dc\u05e9\u05e0\u05d5\u05ea \u05d9\u05e9\u05d9\u05e8\u05d5\u05ea.',
  'story.editDate': 'שינוי מתי זה קרה',
  'story.events': 'אירועים קשורים',
  'story.removeContribution': 'הסרת ההקלטה שלי',
  'story.removeContributionConfirm': 'להסיר את ההקלטה הזאת מהסיפור? שאר ההקלטות נשארות. מנהל/ת יכול/ה לשחזר.',
  'story.locked': 'הסיפור נעול על ידי מנהל/ת.',
  'story.status.local': 'שמור במכשיר הזה',
  'story.status.uploading': 'מעלה… {pct}%',
  'story.status.paused_retry': 'ההעלאה מושהית — ננסה שוב',
  'story.status.action_needed': 'נדרשת פעולה',
  'story.status.uploaded': 'הועלה — הגיבוי ממתין',
  'story.status.backed_up': 'גובה בבטחה',
  'story.status.failed_permanent': 'לא ניתן היה להעלות',
  'story.status.retryIn': 'ניסיון נוסף בעוד {s} שניות',
  'story.status.retry': 'לנסות עכשיו',
  'story.status.pause': 'השהיית ההעלאה',
  'story.status.resume': 'המשך ההעלאה',
  'story.status.actionHelp': 'ההעלאה נכשלה כמה פעמים ({error}). ההקלטה בטוחה במכשיר הזה. נסו שוב, או פנו למנהל/ת.',
  'story.player.play': 'ניגון',
  'story.player.pause': 'השהיה',
  'story.player.unavailable': 'האודיו לא זמין במכשיר הזה (הוקלט במקום אחר ועדיין לא גובה).',
  'story.new': 'חדש',
  'story.notFound': 'הסיפור הזה לא זמין.',
  'story.dateChanged': 'התאריך עודכן.',

  'record.title': 'הקלטת סיפור',
  'record.intro': 'הקליטו זיכרון בקול שלכם — סיפור על מישהו מהמשפחה, רגע, מקום. הוא נשאר בתוך המשפחה, כדי שמי שיבוא אחרינו יוכל לשמוע אותו.',
  'record.step.title': 'כותרת',
  'record.step.record': 'הקלטה',
  'record.step.when': 'מתי',
  'record.step.people': 'אנשים ומקום',
  'record.step.review': 'סיכום',
  'record.whoSpeaks': 'מי מספר/ת את הסיפור?',
  'record.whoSpeaksHelp': 'אפשר להקליט בשם מישהו שאתם עוזרים לנהל. כולם יראו מי דיבר ומי העלה.',
  'record.titleLabel': 'תנו לסיפור כותרת פשוטה',
  'record.titlePlaceholder': 'למשל: איך סבא הגיע לארץ',
  'record.titleLater': 'עזרו לי עם הכותרת אחר כך',
  'record.start': 'הקלטת הסיפור',
  'record.recording': 'מקליט',
  'record.paused': 'מושהה',
  'record.pause': 'השהיה',
  'record.resume': 'המשך',
  'record.finish': 'סיום ההקלטה',
  'record.replay': 'האזנה',
  'record.discard': 'למחוק ולהקליט שוב',
  'record.discardConfirm': 'למחוק את ההקלטה? היא תימחק מהמכשיר הזה.',
  'record.savedOnDevice': 'שמור במכשיר הזה',
  'record.elapsed': 'זמן',
  'memories.recentre': 'חזרה למרכז',
  'memories.openStory': 'פתיחת הסיפור',
  'memories.openRecipe': 'פתיחת המתכון',
  'voice.title': 'לומר משהו על היום הזה',
  'voice.title.recipe': 'לומר משהו על המתכון הזה',
  'voice.help': 'משפט, ברכה, מה שזכור לכם. זה נשמר יחד עם התמונות.',
  'voice.start': 'להתחיל להקליט',
  'voice.stop': 'עצירה',
  'voice.save': 'לשמור',
  'voice.again': 'שוב',
  'voice.saved': 'ההקלטה נוספה',
  'voice.note': 'הקלטה',
  'record.permissionTitle': 'צריך אישור להשתמש במיקרופון',
  'record.permissionHelp': 'הדפדפן ישאל פעם אחת. אם סירבתם בטעות, אפשרו מיקרופון בהגדרות שורת הכתובת ונסו שוב.',
  'record.unsupportedTitle': 'הקלטה לא זמינה כאן',
  'record.unsupported.insecure': 'הקלטה עובדת רק בכתובת מאובטחת (https) או במחשב הזה. פתחו את האפליקציה דרך https כדי להקליט מהטלפון.',
  'record.unsupported.no_api': 'הדפדפן הזה לא יכול להקליט שמע. נסו גרסה עדכנית של Chrome, Safari, Edge או Firefox.',
  'record.typeInstead': 'לכתוב את הסיפור במקום',
  'record.typeLabel': 'כתבו את הזיכרון',
  'record.whenTitle': 'מתי זה קרה?',
  'record.whenHelp': 'בערך זה בסדר גמור. לעולם לא נהפוך ניחוש לתאריך מדויק.',
  'record.peopleTitle': 'מי בסיפור?',
  'record.peopleHelp': 'לא חובה. הקישו כדי להוסיף אנשים.',
  'record.placeTitle': 'איפה זה קרה?',
  'record.placeHelp': 'לא חובה — עיר, או כל מקום אחר: בית ספר, חוף, המטבח של סבתא.',
  'record.reviewTitle': 'סיכום ופרסום',
  'record.publish': 'פרסום',
  'record.saveDraft': 'שמירה כטיוטה פרטית',
  'record.draftSaved': 'הטיוטה שמורה במכשיר הזה. אפשר לחזור אליה מ"סיפורים".',
  'record.published': 'פורסם! ההקלטה שמורה במכשיר הזה ועולה עכשיו.',
  'record.publishOffline': 'אין חיבור. ההקלטה בטוחה במכשיר הזה — פרסמו כשהחיבור יחזור.',
  'record.backgroundNote': 'אפשר לצאת מהמסך הזה. ההעלאות ממשיכות ואפשר לבדוק אותן ב"סיפורים".',
  'record.error.empty': 'עדיין אין הקלטה או טקסט.',
  'record.error.notAllowedFor': 'אפשר להקליט רק עבור עצמכם או עבור אנשים שאתם עוזרים לנהל.',
  'record.resumeDraft': 'יש לך הקלטה לא גמורה',
  'record.resumeDraftHelp': 'היא שמורה במכשיר הזה.',
  'record.resume.continue': 'להמשיך אותה',
  'record.resume.new': 'להתחיל חדשה',
  'record.duration': 'אורך',
  'record.noMic': 'לא נמצא מיקרופון.',

  'date.kind': 'כמה מדויק התאריך?',
  'date.kind.exact': 'תאריך מדויק',
  'date.kind.month': 'חודש ושנה',
  'date.kind.year': 'שנה',
  'date.kind.about': 'בערך שנה',
  'date.kind.decade': 'עשור',
  'date.kind.range': 'בין שתי שנים',
  'date.kind.relative': 'לפי גיל של מישהו',
  'date.kind.before_after': 'לפני או אחרי אירוע',
  'date.kind.unknown': 'לא יודע/ת',
  'date.day': 'תאריך',
  'date.month': 'חודש',
  'date.year': 'שנה',
  'date.fromYear': 'מ',
  'date.toYear': 'עד',
  'date.decade': 'עשור',
  'date.relativePerson': 'מי',
  'date.relativeAge': 'היה/הייתה בערך בגיל',
  'date.beforeAfter': 'לפני או אחרי',
  'date.before': 'לפני',
  'date.after': 'אחרי',
  'date.event': 'אירוע',
  'date.freeText': 'במילים שלכם',
  'date.freeTextPlaceholder': 'למשל "הקיץ שלפני החתונה"',
  'date.preview': 'יוצג כ: {text}',

  'picker.placeholder': 'הקלידו שם…',
  'picker.selected': 'נבחרו',
  'picker.addPerson': 'הוספת {name}',

  'manage.title': 'בקרות מנהל',
  'manage.help': 'כל מה שצריך מנהל, במקום אחד. כל מה שנעשה כאן נשמר בהיסטוריה.',
  'manage.exit': 'חזרה לגלישה',
  'manage.section.review': 'ממתין לבדיקה',
  'manage.section.duplicates': 'כפילויות אפשריות',
  'manage.section.access': 'הזמנות וקודים',
  'manage.section.roles': 'חשבונות ועוזרים',
  'manage.section.locks': 'רשומות נעולות',
  'manage.section.moderation': 'סיפורים ומתכונים',
  'manage.section.jobs': 'העלאות ועיבוד',
  'manage.section.audit': 'היסטוריה ושחזור',
  'manage.section.tree': 'תצוגת העץ',
  'manage.section.prototype': 'בקרות אב-טיפוס',
  'manage.tree.help': 'עיגול גדל כשקורה משהו חדש לאדם — עיגול חדש, סיפור, תמונה — וחוזר לגודלו עם הזמן. גם התגים על שפת העיגול. קבעו כמה גדול, כמה קטן, וכמה זמן.',
  'manage.tree.nodes': 'עיגולים',
  'manage.tree.nodeDefault': 'גודל רגיל',
  'manage.tree.nodeMax': 'גודל כשיש משהו חדש',
  'manage.tree.nodeDays': 'ימים עד שחוזר לגודל רגיל',
  'manage.tree.badges': 'תגים על השפה',
  'manage.tree.badgeMax': 'גודל כשחדש',
  'manage.tree.badgeMin': 'גודל סופי',
  'manage.tree.badgeDays': 'ימים עד שמתכווץ',
  'manage.tree.globe': 'עיגולים על הגלובוס',
  'manage.tree.globeHelp': 'במפת העולם העיגולים גדלים כשמתקרבים וקטנים כשמתרחקים. קבעו כמה קטנים הם במבט על כל העולם וכמה גדולים בהתקרבות מלאה.',
  'manage.tree.globeMin': 'גודל בהתרחקות מלאה',
  'manage.tree.globeMax': 'גודל בהתקרבות מלאה',
  'manage.tree.days': '{n} ימים',
  'manage.tree.scope': 'אלה ההגדרות של המשפחה, לא רק שלכם: הן חלות על כולם, בעץ ובמפת העולם, בכל מכשיר.',
  'manage.tree.saved': 'תצוגת העץ נשמרה.',
  'manage.tree.reset': 'חזרה לברירת המחדל',
  'manage.count': '{n} פריטים',
  'review.approve': 'אישור',
  'review.reject': 'דחייה',
  'review.ask': 'לשאול שאלה',
  'review.askPlaceholder': 'מה תרצו לדעת?',
  'review.rejectReason': 'ספרו ל{name} למה (הם יראו את זה)',
  'review.requestedBy': 'התבקש על ידי {name} {when}',
  'review.onBehalf': 'בשם {name}',
  'review.reason': 'סיבה',
  'review.question': 'שאלה מ{name}',
  'review.answer': 'תשובה',
  'review.answerPlaceholder': 'התשובה שלך…',
  'review.status.pending': 'ממתין',
  'review.status.approved': 'אושר',
  'review.status.rejected': 'לא בוצע',
  'review.status.question': 'נשאלה שאלה',
  'review.approved': 'אושר.',
  'review.rejected': 'סומן כלא בוצע.',
  'review.kind.relationship_add': 'קשר משפחתי חדש',
  'review.kind.relationship_remove': 'הסרת קשר',
  'review.kind.relationship_change': 'שינוי קשר',
  'review.kind.person_field': 'תיקון',
  'review.kind.person_add': 'אדם חדש',
  'review.kind.claim': 'שיוך חשבון',
  'review.kind.merge': 'איחוד',
  'review.kind.conflict_escalation': 'התנגשות עריכה',
  'dup.help': 'איחוד שומר כל סיפור, קשר וחשבון על אדם אחד. הרשומה השנייה נשארת בהיסטוריה.',
  'dup.confidence': '{pct}% סבירות',
  'dup.compare': 'השוואה',
  'dup.notSame': 'לא אותו אדם',
  'dup.merge': 'איחוד…',
  'dup.keep': 'להשאיר את זה',
  'dup.preview.title': 'תצוגה מקדימה של האיחוד',
  'dup.preview.keep': 'יישאר',
  'dup.preview.remove': 'יאוחד לתוכו',
  'dup.preview.relationships': '{n} קשרים עוברים',
  'dup.preview.stories': '{n} סיפורים עוברים',
  'dup.preview.contributions': '{n} הקלטות עוברות',
  'dup.preview.accounts': '{n} חשבונות עוברים',
  'dup.preview.grants': '{n} הרשאות עוזרים עוברות',
  'dup.preview.warn.status': 'לשתי הרשומות מצב חיים שונה.',
  'dup.preview.warn.locked': 'לאחת הרשומות יש שדות נעולים.',
  'dup.preview.warn.twoAccounts': 'לשתי הרשומות יש חשבונות — השיוך השני יצטרך בדיקה.',
  'dup.confirm': 'איחוד האנשים האלה',
  'dup.merged': 'אוחד. ההיסטוריה שומרת את שני המזהים.',
  'merge.error.same': 'בחרו שני אנשים שונים.',
  'access.codes': 'קודי גישה משפחתיים',
  'access.codes.help': 'שתפו במשורה. אחרי הגל הראשון עדיף הזמנות אישיות.',
  'access.codes.new': 'קוד חדש',
  'access.codes.label': 'תווית',
  'access.codes.days': 'בתוקף ל(ימים)',
  'access.codes.uses': '{uses} מתוך {max} שימושים',
  'access.codes.expires': 'פג תוקף {when}',
  'access.codes.revoked': 'בוטל',
  'access.codes.revoke': 'ביטול',
  'access.invites': 'הזמנות אישיות',
  'access.invites.help': 'חד־פעמיות, עם תוקף, קשורות לאדם אחד — הדרך הבטוחה ביותר להכניס מישהו.',
  'access.invites.new': 'להזמין מישהו',
  'access.invites.person': 'אדם בעץ',
  'access.invites.destination': 'אימייל או טלפון',
  'access.invites.send': 'יצירת הזמנה',
  'access.invites.status.pending': 'ממתין',
  'access.invites.status.accepted': 'התקבל',
  'access.invites.status.expired': 'פג תוקף',
  'access.invites.status.revoked': 'בוטל',
  'access.claims': 'שיוכי חשבונות',
  'access.claims.help': 'אנשים שהצטרפו עם קוד המשפחה וביקשו להתחבר לאדם בעץ.',
  'access.temp': 'גישה זמנית ממכשיר',
  'access.temp.adminHelp': 'לבני משפחה ללא אימייל או טלפון. כל קוד קשור למכשיר אחד וניתן לביטול.',
  'access.temp.new': 'הנפקת קוד מכשיר',
  'access.temp.person': 'עבור',
  'access.temp.device': 'שם המכשיר',
  'access.temp.issue': 'הנפקת קוד',
  'access.temp.status.active': 'פעיל',
  'access.temp.status.revoked': 'בוטל',
  'access.temp.status.expired': 'פג תוקף',
  'access.temp.notRedeemed': 'עדיין לא נוצל',
  'access.temp.revoke': 'ביטול',
  'roles.help': 'כל מי שיש לו חשבון, בתור מי הוא מחובר, ומה מותר לו.',
  'roles.change': 'שינוי תפקיד',
  'roles.error.lastAdmin': 'זה/זו המנהל/ת האחרון/ה. קודם מנו מישהו אחר למנהל/ת.',
  'roles.helpers': 'עוזרי פרופיל',
  'roles.helpersHelp': 'עוזר/ת מנהל/ת אנשים ספציפיים — לעולם לא ענף שלם — בלי לשתף סיסמאות.',
  'roles.grant': 'הוספת עוזר/ת',
  'roles.grant.helper': 'עוזר/ת (חשבון)',
  'roles.grant.person': 'מנהל/ת את',
  'roles.grant.scope': 'מה מותר',
  'roles.scope.full': 'עריכת פרופיל והקלטת סיפורים',
  'roles.scope.record_only': 'הקלטת סיפורים בלבד',
  'roles.grant.submit': 'הוספת עוזר/ת',
  'roles.revoke': 'הסרה',
  'roles.disconnect': 'ניתוק החשבון מהאדם',
  'locks.help': 'נעילה לא מקפיאה שום דבר. כל עוד היא פועלת, שינוי הופך להצעה שמנהל מאשר — כך ששום דבר חשוב לא משתנה בטעות.',
  'locks.unlock': 'שחרור',
  'locks.lock': 'נעילה',
  'locks.reason': 'סיבה (מוצגת לבני המשפחה)',
  'locks.fields': 'אילו פרטים?',
  'moderation.help': 'לנעול סיפור כך ששינויים בו יגיעו כהצעות, להוריד סיפור או מתכון, או להחזיר אחד. שום דבר לא נמחק, וכל פעולה כאן נרשמת.',
  'moderation.archive': 'הורדה',
  'moderation.restore': 'להחזיר',
  'moderation.lock': 'נעילה',
  'moderation.unlock': 'שחרור',
  'moderation.archived': 'הורד',
  'jobs.help': 'הקלטות שלא הצליחו לעלות, להיות מתומללות או מגובות.',
  'jobs.kind.upload': 'העלאה',
  'jobs.kind.transcription': 'תמלול',
  'jobs.kind.backup': 'גיבוי',
  'jobs.kind.processing': 'עיבוד',
  'jobs.retry': 'לנסות שוב',
  'jobs.retried': 'הניסיון החוזר התחיל.',
  'jobs.attempts': '{n} ניסיונות',
  'audit.help': 'כל שינוי חשוב, מי עשה אותו ומתי. שחזור יוצר שינוי מפצה חדש — ההיסטוריה לעולם לא נמחקת.',
  'audit.restore': 'שחזור הערכים הקודמים',
  'audit.restored': 'שוחזר.',
  'audit.error.notRestorable': 'אי אפשר לשחזר את הרשומה הזאת אוטומטית.',
  'audit.filter': 'סינון לפי אדם',
  'audit.action.create': 'נוצר',
  'audit.action.update': 'עודכן',
  'audit.action.archive': 'הוסר',
  'audit.action.restore': 'שוחזר',
  'audit.action.approve': 'אושר',
  'audit.action.reject': 'נדחה',
  'audit.action.merge': 'אוחד',
  'audit.action.lock': 'ננעל',
  'audit.action.unlock': 'שוחרר',
  'audit.action.publish': 'פורסם',
  'audit.action.role_change': 'תפקיד שונה',
  'audit.action.grant': 'הרשאה ניתנה',
  'audit.action.revoke': 'הרשאה בוטלה',
  'audit.action.sign_in': 'התחבר/ה',
  'audit.action.claim': 'שיוך',
  'audit.before': 'לפני',
  'audit.after': 'אחרי',

  'notif.title': 'התראות',
  'notif.starred': 'מסומן בכוכב',
  'notif.empty': 'אין חדש.',
  'notif.markRead': 'סימון כנקרא',

  'settings.title': 'הגדרות',
  'settings.language': 'שפה',
  'settings.experience': 'פשוט או מתקדם',
  'settings.experience.help': 'במצב פשוט האפליקציה מצטמצמת לעץ המשפחה ולהוספת דברים. מצב מתקדם פותח את הכול.',
  'settings.experience.simple': 'פשוט',
  'settings.experience.simple.help': 'עץ המשפחה וכפתור ההוספה לתמונות, אירועים וסיפורים. פחות כפתורים, פחות ללמוד.',
  'settings.experience.advanced': 'מתקדם',
  'settings.experience.advanced.help': 'הכול: גלובוס העולם, רגעים, לשונית הסיפורים, התראות ועוד.',
  'settings.adminTab': 'כלי ניהול',
  'settings.adminTab.show': 'להציג את כלי הניהול בסרגל התחתון',
  'settings.adminTab.help': 'כיבוי מסתיר את לשונית כלי הניהול. נשארים מנהלים, ואפשר להחזיר אותה כאן בכל עת.',
  'settings.theme': 'מראה',
  'settings.theme.help': 'כהה נוח יותר לעיניים בערב; בהיר נוח יותר באור יום חזק.',
  'settings.theme.dark': 'כהה',
  'settings.theme.light': 'בהיר',
  'settings.theme.system': 'לפי הגדרת המכשיר',
  'settings.motion': 'תנועה',
  'settings.motion.help': 'כיבוי הריחוף העדין של האנשים בעץ ותנועות גדולות.',
  'settings.motion.system': 'לפי הגדרת המכשיר',
  'settings.motion.reduce': 'להפחית תנועה',
  'settings.motion.full': 'לאפשר תנועה',
  'settings.textSize': 'גודל טקסט',
  'settings.textSize.normal': 'רגיל',
  'settings.textSize.large': 'גדול יותר',
  'settings.textSize.xlarge': 'הכי גדול',
  'settings.account': 'חשבון',
  'settings.account.email': 'אימייל',
  'settings.account.phone': 'טלפון',
  'settings.account.temporary': 'מחובר/ת עם קוד מכשיר',
  'settings.devices': 'מכשירים',
  'settings.about': 'על האב־טיפוס',
  'settings.aboutText': 'אב־טיפוס: כל מה שאתם עושים נשמר בדפדפן הזה בלבד.',

  'proto.title': 'אב־טיפוס',
  'proto.open': 'בקרות אב־טיפוס',
  'proto.help': 'דמו תנאים מהעולם האמיתי כדי לבדוק את החוויה.',
  'proto.offline': 'דימוי ניתוק מהאינטרנט',
  'proto.latency': 'עיכוב רשת',
  'proto.latency.none': 'אין',
  'proto.latency.normal': 'רגיל',
  'proto.latency.slow': 'איטי',
  'proto.latency.verySlow': 'איטי מאוד',
  'proto.failures': 'כשלי שמירה אקראיים',
  'proto.failures.none': 'כבוי',
  'proto.failures.some': 'מעט',
  'proto.failures.many': 'הרבה',
  'proto.uploadFailures': 'העלאות לא יציבות',
  'proto.slowUploads': 'העלאות איטיות',
  'proto.otherEditor': 'מישהו אחר עורך את האדם הפתוח',
  'proto.otherEditor.help': 'פתחו קודם מסך עריכה של מישהו, לחצו כאן, ואז שמרו — תראו את תהליך ההתנגשות.',
  'proto.otherEditor.done': '{by} שינה/תה עכשיו את "{field}". עכשיו שמרו את העריכה שלכם כדי לראות את ההתנגשות.',
  'proto.otherEditor.none': 'פתחו קודם מסך "עריכת פרטים" של מישהו.',
  'proto.incomingStory': 'מישהו מפרסם סיפור עכשיו',
  'proto.incomingStory.done': 'לאה פרסמה עכשיו סיפור. שימו לב לבועה שלה בעץ.',
  'proto.secondTab': 'פתיחת כרטיסייה שנייה',
  'proto.secondTab.help': 'התחברו כאדם אחר בכרטיסייה ההיא (רק שם) כדי לבדוק עדכונים חיים ונוכחות.',
  'proto.switchUser': 'החלפת משתמש (רק בכרטיסייה זו)',
  'proto.reset': 'איפוס נתוני ההדגמה',
  'proto.reset.confirm': 'לאפס את כל נתוני ההדגמה בדפדפן הזה? ההקלטות והשינויים שלכם יימחקו.',
  'proto.reset.done': 'נתוני ההדגמה אופסו.',
  'proto.export': 'העתקת הנתונים כ-JSON',
  'proto.exported': 'הועתק.',
  'proto.storage': 'נשמר בדפדפן הזה (IndexedDB)',
  'proto.pictures': 'תמונות בדפדפן הזה',
  'proto.picturesCheck': 'בדיקת התמונות',
  'proto.picturesCounts': 'תמונות מעגל {portraits} · תמונות וסרטונים {photos} · {size}',
  'proto.picturesAllOk': 'כולן נקראות כראוי',
  'proto.picturesBroken': '{n} לא ניתנות לקריאה',
  'proto.picturesOrphans': '{n} קבצים שנשארו בלי שום רשומה שמצביעה עליהם',
  'proto.picturesRepair': 'ניקוי מה שחסר',
  'proto.picturesRepaired': 'נוקו {n} הפניות שבורות ו-{t} קבצים שנשארו',
  'proto.picturesMemory': 'לא ניתן היה לפתוח את האחסון — הפעלה זו רצה מהזיכרון',
  'proto.demoCodes': 'קודים לדוגמה',
  'proto.demoCodes.access': 'קוד גישה משפחתי: {code}',
  'proto.demoCodes.temp': 'קוד המכשיר של מרים: {code}',
  'proto.demoCodes.invite': 'ההזמנה של נטלי: {code}',
  'proto.demoCodes.phone': 'קוד טלפון: {code}',
  // ---- where people live / World tab ----
  'nav.world': 'עולם',
  'nav.calendar': 'לוח שנה',
  'nav.passedDown': 'מדור לדור',
  'calendar.title': 'הימים של המשפחה',
  'calendar.loading': 'טוען את ציר הזמן…',
  'calendar.hint': 'גררו לצדדים או גלגלו · מה שהיה בתחילת הקו, מה שמתקרב בסופו · הקישו על יום',
  'calendar.today': 'היום',
  'calendar.backToToday': 'חזרה להיום',
  'calendar.isToday': 'היום',
  'calendar.yesterday': 'אתמול',
  'calendar.inDays': 'בעוד {n} ימים',
  'calendar.daysAgo': 'לפני {n} ימים',
  'calendar.empty': 'עדיין אין כלום על הקו — ימי הולדת מופיעים כשממלאים תאריכי לידה, ואירועים כשמישהו משתף אחד.',
  'calendar.filter.label': 'מה להציג',
  'calendar.view.label': 'תצוגת לוח השנה',
  'calendar.view.line': 'ימים',
  'calendar.view.week': 'שבוע',
  'calendar.view.month': 'חודש',
  'calendar.earlier': 'קודם',
  'calendar.later': 'הבא',
  'calendar.nothingOn': 'אין כלום ביום הזה.',
  'calendar.onDay': '{n} ביום הזה',
  'calendar.filter.birthdays': 'ימי הולדת',
  'calendar.filter.events': 'אירועים',
  'calendar.filter.anniversaries': 'ימי נישואין',
  'calendar.filter.yahrzeits': 'אזכרות',
  'calendar.filter.holidays': 'חגים',
  'calendar.kind.birthday': 'יום הולדת',
  'calendar.kind.anniversary': 'יום נישואין',
  'world.title': 'איפה המשפחה גרה',
  'world.hint': 'גררו כדי לסובב את הגלובוס · גלגלו או צבטו כדי להתקרב · הקישו על עיגול',
  'world.centerMe': 'איפה אני',
  'world.everyone': 'כולם',
  'world.find': 'חיפוש אדם',
  'world.zoomIn': 'התקרבות',
  'world.zoomOut': 'התרחקות',
  'world.people': '{n} אנשים כאן',
  'world.people.one': 'אדם אחד כאן',
  'world.inCity': 'ב{city}',
  'world.nearby': 'קרובים זה לזה — התקרבו כדי לראות את כולם',
  'world.notOnMap': 'עדיין לא על המפה',
  'world.notOnMap.help': 'לקרובים האלה עדיין אין עיר מגורים.',
  'world.notOnMap.more': 'ועוד {n}',
  'world.addMine': 'הוספת מקום המגורים שלי',
  'world.empty.title': 'עדיין אין אף אחד על המפה',
  'world.empty.help': 'לשונית העולם מראה איפה כולם גרים ומי מבקר איפה. היא מתמלאת ככל שקרובים מוסיפים את העיר שלהם.',
  'world.loading': 'טוען את הגלובוס…',
  'world.noData': 'קווי המפה עדיין לא נבנו — יש להריץ node scripts/build-world-data.mjs.',
  'world.visiting': 'בביקור',
  'world.visitingUntil': 'בביקור ב{city} עד {date}',
  'world.visitingFrom': 'ב{city} מ־{from} עד {to}',
  'world.legend': 'איך לקרוא את הגלובוס',
  'world.legend.home': 'עיגול יושב במקום שבו האדם גר',
  'world.legend.visit': 'טבעת מקווקוות: כרגע בביקור במקום אחר',
  'world.legend.cluster': 'מספר: כך וכך אנשים קרובים זה לזה — התקרבו',
  'world.legend.stem': 'קו קצר: העיגול הוזז מעט כדי לפנות מקום — הנקודה היא המקום האמיתי',
  'world.legend.sun': 'שמש וירח: איפה הם עכשיו; הצד הכהה הוא לילה',
  'world.legend.you': 'טבעת טורקיז: אתם · טבעת זהב: אנשים שסימנתם בכוכב',
  'world.data.credit': 'מפה: Natural Earth · ערים: GeoNames',

  'places.livesInShort': 'מקום מגורים',
  'places.noHome': 'עדיין אין עיר מגורים',
  'places.home': 'בית',
  'places.homeHelp': 'המשפחה רואה את העיר שלכם בלשונית העולם. שום דבר מדויק יותר, אלא אם תוסיפו.',
  'places.search': 'חיפוש עיר',
  'places.searchHint': 'הקלידו שם עיר — למשל חיפה, טורונטו, פריז',
  'places.noResults': 'לא נמצאה עיר. נסו איות אחר, או את העיר הגדולה הקרובה.',
  'places.searching': 'מחפש…',
  'places.anywhereHint': 'הקלידו עיר — או כל מקום אחר',
  'places.useTyped': 'להשתמש ב“{text}”',
  'places.change': 'שינוי',
  'places.clear': 'הסרה',
  'places.precise': 'לדייק יותר (לא חובה)',
  'places.preciseLabel': 'שכונה או אזור',
  'places.preciseHelp': 'מוצג רק יחד עם העיר, למשל “הכרמל, חיפה, ישראל”. השאירו ריק כדי להישאר ברמת עיר.',
  'places.picked': 'נבחר: {label}',
  'places.visits': 'ביקורים',
  'places.visitsHelp': 'נוסעים לאנשהו? הוסיפו תאריכים והמפה תעביר אתכם לשם לזמן הנסיעה. ביקורים שהיו נשמרים ברשומה.',
  'places.addVisit': 'הוספת ביקור',
  'places.visit.where': 'לאן?',
  'places.visit.from': 'יום ראשון',
  'places.visit.to': 'יום אחרון',
  'places.visit.note': 'הערה (לא חובה)',
  'places.visit.noteHint': 'למשל פסח עם המשפחה',
  'places.visit.save': 'שמירת הביקור',
  'places.visit.saved': 'הביקור נוסף',
  'places.visit.cancel': 'ביטול הביקור',
  'places.visit.cancelled': 'הביקור בוטל',
  'places.visit.cancelledMark': 'בוטל',
  'places.visit.now': 'שם עכשיו',
  'places.visit.upcoming': 'בקרוב',
  'places.visit.past': 'עבר',
  'places.visit.none': 'אין ביקורים מתוכננים.',
  'places.visitDenied': 'רק האדם עצמו (או מי שעוזר עם הפרופיל שלו) יכול להוסיף ביקורים.',
  'places.invalidDate': 'יש לבחור את שני התאריכים.',
  'places.endBeforeStart': 'היום האחרון מוקדם מהיום הראשון.',
  'places.tooLong': 'ביקור יכול להימשך עד שנה — למשך זמן ארוך יותר, שנו את עיר המגורים.',
  'places.inPast': 'התאריכים האלה לפני יותר משנה.',
  'places.record': 'מקומות',
  'places.record.help': 'כל בית וכל ביקור מאז ההצטרפות, מהחדש לישן.',
  'places.record.since': 'מאז {date}',
  'places.record.until': 'עד {date}',
  'places.record.range': '{from} – {to}',
  'places.homeSaved': 'עיר המגורים נשמרה',
  'places.nudge': 'הוספת מקום המגורים',
  'places.nudgeHelp': 'שימו את עצמכם על מפת המשפחה',
  'places.privacy': 'המשפחה רואה את העיר שלכם על מפת העולם. שום דבר מדויק יותר, אלא אם תוסיפו.',

  'onb.home.title': 'איפה אתם גרים?',
  'onb.home.help': 'מספיק שם עיר. זה שם אתכם על מפת העולם של המשפחה ומאפשר לאפליקציה לדעת מה השעה אצלכם.',
  'onb.home.skip': 'לדלג בינתיים',
  'onb.review.home': 'מקום מגורים',

  'tree.legend.visit': 'מזוודה קטנה: כרגע בביקור במקום אחר',

  // ---- the Add tab ----
  'add.tab': 'הוספה',
  'add.sheetTitle': 'להוסיף משהו',
  'add.subtitle': 'לשתף תמונה, להוסיף אירוע, להקליט סיפור — הכול מתחיל כאן.',
  'add.photo': 'לשתף תמונה',
  'add.photoHelp': 'רגע מצולם, תמונה ישנה.',
  'add.event': 'להוסיף אירוע',
  'add.eventHelp': 'ארוחה, טיול, מפגש.',
  'add.story': 'להקליט סיפור',
  'add.storyHelp': 'בקול, או בכתב.',
  'add.relative': 'להוסיף קרוב/ת משפחה',
  'photos.choosePicture': 'לבחור תמונה',
  'photos.changePicture': 'לבחור תמונה אחרת',
  'photos.emptyHint': 'בלחצן + למטה אפשר לשתף את הראשונה.',

  // ---- Shabbat ----
  'shabbat.now': 'שבת עכשיו',
  'shabbat.nowFor': 'עכשיו שבת במקום שבו {name} נמצא/ת',
  'shabbat.shalom': 'שבת שלום',
  'shabbat.quietTitle': 'מצב שבת — ההתראות ממתינות',
  'shabbat.quietBody': 'מצב שבת פעיל. כל מה שיגיע במהלך השבת יחכה כאן עד צאתה.',
  'tree.legend.shabbat': 'שני נרות למעלה: עכשיו שבת אצלם — טורקיז אצלך, זהב אצל מסומני כוכב, ואחרת בצבע שלהם',
  'settings.gestures': 'ניווט',
  'settings.tapBack': 'הקשה על הרקע חוזרת אחורה',
  'settings.tapBack.help': 'במעגל התמונות, הקשה על השטח הריק שסביבן חוזרת אחורה — בדיוק כמו הפינה.',
  'settings.tabTips.reset': 'להציג שוב את ההסברים על הלשוניות',
  'settings.tabTips.help': 'כל לשונית בתחתית מסבירה בשביל מה היא, עד שסוגרים את ההסבר שלה ב־×. הכפתור הזה מחזיר את כולם.',
  'settings.tabTips.closed': 'הסברים שסגרתם: {count}',
  'settings.tabTips.allShowing': 'כל ההסברים מוצגים.',
  'settings.tabTips.done': 'בוצע — כל לשונית תסביר את עצמה שוב.',
  // בשביל מה כל לשונית — נאמר בבועה מעל השורה התחתונה עד שלוחצים על ה־× שלה (app/tabTips.ts).
  'tabTip.close': 'סגירת ההסבר',
  'tabTip.tree': 'כל המשפחה, כעיגולים. מקישים על עיגול כדי לפתוח את האדם — התמונות, הסיפורים והמתכונים שלו מרחפים סביבו.',
  'tabTip.world': 'איפה כולם גרים, ומי מבקר איפה. מסובבים את הגלובוס ומקישים על פנים.',
  'tabTip.timeline': 'הסיפורים, הלידות והימים הגדולים של המשפחה, אחורה לאורך השנים. מקישים על אחד כדי לפתוח את כל מה שבתוכו.',
  'tabTip.calendar': 'מה שמתקרב — ימי הולדת, ימי נישואין, ימי זיכרון והחגים — כדי שאף יום לא יתפספס.',
  'tabTip.passedDown': 'מתכונים, ידע וסודות של המשפחה — נשמרים כאן כדי שלא ילכו לאיבוד. מקישים על אחד כדי לפתוח אותו; לוחצים על + כדי לכתוב חדש.',
  'settings.shabbat': 'שבת',
  'settings.shabbat.mode': 'מצב שבת',
  'settings.shabbat.help': 'מהדלקת נרות ועד צאת השבת, במקום שבו את/ה נמצא/ת, האפליקציה שומרת על שקט.',
  'settings.shabbat.nowQuiet': 'עכשיו שבת אצלך — ההתראות מוחזקות.',
  'settings.shabbat.notNow': 'עכשיו לא שבת. האפליקציה תשקוט בהדלקת נרות.',

  // ---- family milestones (simchas) ----
  'add.milestone': 'להוסיף שמחה משפחתית',
  'add.milestoneHelp': 'חתונה, בר מצווה, תינוק חדש.',
  'photos.addMilestoneTitle': 'שמחה משפחתית',
  'photos.milestoneWhich': 'מזל טוב! מה השמחה?',
  'photos.milestoneChange': 'לשנות',
  'photos.milestoneTitle': 'של מי השמחה, ומה היא?',
  'photos.shareMilestone': 'לשתף את הבשורה',
  'photos.savedMilestone': 'שותף עם המשפחה — מזל טוב!',
  'photos.milestoneMark': 'שמחה משפחתית',
  'milestone.wedding': 'חתונה',
  'milestone.engagement': 'אירוסין',
  'milestone.birth': 'תינוק/ת חדש/ה',
  'milestone.brit': 'ברית / זבד הבת',
  'milestone.barMitzvah': 'בר מצווה',
  'milestone.batMitzvah': 'בת מצווה',
  'milestone.graduation': 'סיום לימודים',
  'milestone.newHome': 'בית חדש',
  'milestone.aliyah': 'עלייה לארץ',
  'milestone.anniversary': 'יום נישואין',
  'milestone.memorial': 'לזכרו/ה',
  'milestone.other': 'משהו אחר',
  'milestone.hint.wedding': 'החתונה של נועה ותום',
  'milestone.hint.engagement': 'נועה ותום התארסו',
  'milestone.hint.birth': 'ברוך הבא, ליאור',
  'milestone.hint.brit': 'הברית של ליאור',
  'milestone.hint.barMitzvah': 'בר המצווה של איתן',
  'milestone.hint.batMitzvah': 'בת המצווה של נועה',
  'milestone.hint.graduation': 'מאיה סיימה את הטכניון',
  'milestone.hint.newHome': 'משפחת כץ עברה לחיפה',
  'milestone.hint.aliyah': 'דניאל עלה לארץ',
  'milestone.hint.anniversary': 'יום הנישואין ה‑50 של סבתא וסבא',
  'milestone.hint.memorial': 'לזכר סבא יוסף',
  'milestone.hint.other': 'מה קרה, ולמי',
  /* ---- כל יום שהמשפחה זוכרת הוא מקום שאפשר למלא: שמחה, סיפור, הולדת ---- */
  'memories.add': 'הוספת תמונות או סרטונים',
  'memories.addShort': 'הוספה',
  'memories.adding': 'מוסיף {done} מתוך {total}…',
  'memories.added': '{n} נוספו',
  'memories.addFailed': 'לא הצלחנו להוסיף {n} — גדול מדי, או לא תמונה או סרטון',
  'memories.count': '{n} תמונות וסרטונים',
  'memories.empty': 'עוד אין כאן כלום.',
  'memories.emptyHint': 'הוסיפו את התמונות והסרטונים הראשונים מהיום הזה — כל אחד במשפחה יכול להוסיף משלו.',
  'memories.backToAll': 'הכול',
  'memories.video': 'סרטון',
  'nodes.details': 'פרטים',
  'nodes.addToPerson': 'הוספה ל{name}',
  'nodes.recordStory': 'להקליט סיפור',
  'nodes.nothing': 'אין כאן עדיין כלום.',
  'nodes.nothingHint': 'התמונות, הסיפורים והמתכונים שלהם יופיעו כאן מסביב.',
  'tree.openCircle': 'פתיחת {name}',
  'memories.photo': 'תמונה',
  'filters.all': 'לבחור הכול',
  'filters.none': 'לנקות',
  'filters.noneChosen': 'לא סומן כלום, ולכן לא מוצג כלום.',
  'filters.show': 'להציג',
  'photos.zoomIn': 'תמונות גדולות יותר',
  'photos.zoomOut': 'תמונות קטנות יותר',
  'photos.kind.photo': 'תמונות',
  'photos.kind.video': 'סרטונים',
  'photos.kind.voice': 'הקלטות',
  'photos.kind.event': 'אירועים',
  'photos.kind.milestone': 'רגעים גדולים',
  'memories.partOf': 'חלק מ{name}',
  'memories.main': 'התמונה הראשית',
  'memories.makeMain': 'להפוך לתמונה הראשית',
  'memories.madeMain': 'זו עכשיו התמונה הראשית',
  'memories.birthTitle': 'הימים הראשונים של {name}',
  'memories.birthKind': 'הולדת',
  'memories.storyTitle': 'תמונות מהסיפור הזה',
  'memories.storyHint': 'עוד אין כלום — הוסיפו תמונה או סרטון מהיום שהסיפור מספר עליו.',

  // ---- prototype: Shabbat simulation ----
  'proto.shabbat': 'להעמיד פנים שעכשיו שבת',
  'proto.shabbat.help': 'הנרות עוקבים בדרך כלל אחרי השקיעה האמיתית במקום של כל אחד/ת. סימון של אנשים כאן מדליק את הנרות שלהם עכשיו — ואצלך זה גם מפעיל את השקט של מצב שבת. ביטול הסימון מחזיר לשעון האמיתי.',
  'proto.shabbat.everyone': 'שבת אצל כולם עכשיו',
  'proto.shabbat.people': 'שבת אצל האנשים האלה',
  'proto.shabbat.clear': 'לנקות',
  'proto.shabbat.real': 'באמת שבת שם עכשיו',
  'proto.shabbat.status': 'מעמידים פנים אצל {n} · באמת שבת עכשיו אצל {real}',

  // ---- latest strip: posted / tagged; tagging people in stories ----
  'tree.card.posted': 'שיתפ/ה',
  'tree.card.tagged': 'מתויג/ת',
  'tree.card.postedEmpty': 'עדיין לא שותף כלום.',
  'tree.card.taggedEmpty': 'עדיין לא תויג/ה בשום תמונה או סיפור.',
  'story.tag': 'לתייג אנשים',
  'story.tagEdit': 'לערוך',
  'story.tagEmpty': 'עדיין לא תויג אף אחד בסיפור הזה.',
  'story.tagTitle': 'מי בסיפור הזה?',
  'story.tagHelp': 'לתייג את מי שהסיפור עליהם או שהיו שם — הוא יופיע אז תחת „מתויג/ת” בעיגול שלהם.',
  'story.tagPick': 'אנשים בסיפור',
  'story.tagSaved': 'האנשים בסיפור עודכנו.',

  // ---- בקרוב: ימי הולדת, ימי נישואין, אזכרות וחגים ----
  'occasion.comingUp': 'בקרוב',
  'occasion.today': 'היום',
  'occasion.tomorrow': 'מחר',
  'occasion.birthday': '{name} חוגג/ת {n}',
  'occasion.birthdayNoAge': 'יום ההולדת של {name}',
  'occasion.anniversary': '{names}: {n} שנות נישואין',
  'occasion.anniversaryNoYears': '{names}: יום נישואין',
  'occasion.yahrzeit': 'האזכרה של {name} · {hebrew}',
  'occasion.yahrzeitChip': 'אזכרה {hebrew} · {date}',
  'occasion.yahrzeitToday': 'אזכרה היום',
  'occasion.yahrzeitLong': 'אזכרה ב{hebrew} — השנה ב־{date}',
  'tree.legend.occasion': 'עוגה, לב או נר קטן משמאל: יום הולדת, יום נישואין או אזכרה היום',
  'tree.arrange.age': 'סידור לפי גיל',
  'tree.arrange.generations': 'סידור לפי דורות',
  'tree.legend.age': 'לפי גיל: ככל שגבוה יותר, נולד מוקדם יותר — זוג יושב בממוצע שלהם; השנים רשומות משמאל',
  'holiday.roshHashana': 'ראש השנה',
  'holiday.yomKippur': 'יום כיפור',
  'holiday.sukkot': 'סוכות',
  'holiday.simchatTorah': 'שמחת תורה',
  'holiday.chanukah': 'חנוכה',
  'holiday.tuBishvat': 'ט״ו בשבט',
  'holiday.purim': 'פורים',
  'holiday.pesach': 'פסח',
  'holiday.yomHaatzmaut': 'יום העצמאות',
  'holiday.lagBaomer': 'ל״ג בעומר',
  'holiday.shavuot': 'שבועות',
  'holiday.tishaBav': 'תשעה באב',
  'holiday.greeting.shanaTova': 'שנה טובה!',
  'holiday.greeting.gmar': 'גמר חתימה טובה',
  'holiday.greeting.fast': 'צום קל',
  'holiday.greeting.chag': 'חג שמח!',

  // ---- להגיע לבן/בת משפחה: שעה מקומית, וואטסאפ / שיחה / מייל ----
  'reach.message': 'הודעה בוואטסאפ',
  'reach.whatsapp': 'וואטסאפ',
  'reach.instagram': 'אינסטגרם',
  'reach.instagramOpen': 'לאינסטגרם שלהם',
  'reach.facebook': 'פייסבוק',
  'reach.facebookOpen': 'לפייסבוק שלהם',
  'reach.instagramHint': '‎@שם משתמש או קישור',
  'reach.facebookHint': 'שם או קישור',
  'reach.shabbatHint': 'עכשיו שבת אצלם',
  'reach.section': 'איך המשפחה יכולה להשיג אותך',
  'reach.help': 'מספר טלפון או מייל, לשיחה או להודעת וואטסאפ ישר מהעיגול שלך בעץ. שום דבר לא מוצג לאיש עד שמדליקים את השיתוף.',
  'reach.phone': 'טלפון',
  'reach.phoneHint': '+972 52 …',
  'reach.emailLabel': 'מייל',
  'reach.share': 'לשתף עם המשפחה',
  'reach.shareHelp': 'בני המשפחה יראו בעיגול הזה כפתורי הודעה, שיחה ומייל. אפשר לכבות בכל רגע.',

  // ---- לשאול אותם משהו ----
  'ask.button': 'לשאול את {name} משהו',
  'ask.buttonShort': 'לשאול',
  'ask.title': 'לשאול את {name} משהו',
  'ask.help': 'השאלה מחכה ל{name} בפעמון ובפרופיל, והתשובה היא סיפור.',
  'ask.label': 'השאלה שלך',
  'ask.placeholder': 'איך הכרת את סבתא? איך נראה הבית בקזבלנקה?',
  'ask.send': 'לשלוח את השאלה',
  'ask.sent': 'נשלח — {name} יראה/תראה את זה.',
  'ask.prompt.meet': 'איך הכרתם, את/ה ובן/בת הזוג?',
  'ask.prompt.child': 'מה את/ה זוכר/ת מהילדות?',
  'ask.prompt.recipe': 'איזו מנה יש לה טעם של בית, ואיך מכינים אותה?',
  'ask.prompt.advice': 'מה הדבר האחד שהיית רוצה שנזכור?',
  'ask.error.empty': 'קודם כותבים את השאלה.',
  'ask.error.deceased': 'אפשר לשאול רק את החיים — אבל אפשר להקליט זיכרון עליהם.',
  'ask.section': 'שאלות ל{name}',
  'ask.askedBy': 'שאל/ה {name}',
  'ask.askedBySomeone': 'שאל/ה בן/בת משפחה',
  'ask.answer': 'לענות',
  'ask.dismiss': 'להניח בצד',
  'ask.dismissed': 'השאלה הונחה בצד.',
  'ask.answered': 'נענה',
  'ask.answeredWith': 'נענה עם',
  'ask.alreadyAnswered': 'על השאלה הזו כבר ענו — עדיין אפשר להקליט סיפור משלך.',
  'ask.alreadySetAside': 'השאלה הזו הונחה בצד — עדיין אפשר להקליט סיפור משלך.',
  'ask.notYours': 'השאלה הזו מיועדת ל{name}. רק הם (או מי שמקליט/ה בשבילם) יכולים לענות — אבל זיכרון משלך תמיד מתקבל בברכה כסיפור.',
  'notif.questionMark': 'שאלה',
  'notif.visitMark': 'מגיע/ה לעיר',
  'record.answering': 'תשובה לשאלה של {name}',
  'record.answeringSomeone': 'תשובה לשאלה',
  'story.answersQuestion': 'סופר כתשובה לשאלה',
  'story.answersQuestionBy': 'סופר כתשובה לשאלה של {name}',

  // ---- תגובות על סיפורים, סיפורים על אדם ----
  'story.react': 'התגובה שלך',
  'story.react.add': '\u05dc\u05d4\u05e9\u05d0\u05d9\u05e8 \u05ea\u05d2\u05d5\u05d1\u05d4',
  'story.reacted': 'נשלח.',
  'story.reactionRemoved': 'הוסר.',
  'profile.storiesTold': 'סיפר/ה {name}',
  'profile.storiesAbout': 'סיפורים על {name}',
  'profile.storiesAboutHelp': 'סיפורים שהם מופיעים בהם — שסיפרו אחרים.',

  // ---- מנהלים ----
  'manage.section.admins': 'מנהלים',
  'manage.section.decisions': 'החלטות מנהלים',
  'admin.colourNote': 'כל מה שבצבע הזה הוא כלי ניהול.',
  'admins.help': 'מנהלים נקבעים לפי כתובת אימייל. הרשימה משתנה רק בהסכמת המנהלים — אי אפשר להוסיף את עצמך.',
  'admins.current': 'המנהלים כרגע',
  'admins.active': 'פעיל/ה',
  'admins.quiet': 'לא נראה/תה לאחרונה',
  'admins.notJoined': 'עוד לא התחבר/ה',
  'admins.lastSeen': 'פעילות אחרונה {when}',
  'admins.neverSeen': 'עוד אין רישום',
  'admins.stepDown': 'לוותר על הניהול',
  'admins.stepDownHelp': 'תפסיק/י להיות מנהל/ת ותהיה/י עורך/ת משפחה. מנהל/ת אחר/ת יוכל/תוכל להציע אותך שוב.',
  'admins.steppedDown': 'אינך מנהל/ת יותר.',
  'admins.suggest': 'להציע מנהל/ת',
  'admins.suggestHelp': 'צריך רוב מבין המנהלים שהיו פעילים לאחרונה — {n} מתוך {total} כרגע. אם אף אחד לא מתנגד, זה עובר מעצמו אחרי {days} ימים.',
  'admins.suggestAction': 'להציע',
  'admins.suggested': 'ההצעה נשלחה. שאר המנהלים קיבלו הודעה.',
  'admins.email': 'כתובת האימייל שלהם',
  'admins.reason': 'למה (לא חובה)',
  'admins.reasonPlaceholder': 'היא ממילא מטפלת בתמונות',
  'admins.openTitle': 'ממתין למנהלים',
  'admins.tally': '{yes} מתוך {needed}',
  'admins.autoIn': 'אף אחד לא התנגד — זה יעבור בעוד {days} ימים אם זה יישאר כך.',
  'admins.needsFirstApproval': 'ממתין לאישור הראשון.',
  'admins.objected': '{n} התנגדו. עכשיו צריך רוב מלא.',
  'admins.approve': 'לאשר',
  'admins.youApproved': 'אישרת',
  'admins.object': 'להתנגד',
  'admins.youObjected': 'התנגדת',
  'admins.objectHelp': 'התנגדות עוצרת את המעבר האוטומטי. ההצעה עדיין יכולה לעבור ברוב.',
  'admins.voted': 'נרשם.',
  'admins.withdraw': 'לבטל את ההצעה',
  'admins.withdrawn': 'ההצעה בוטלה.',
  'admins.settled': 'הוכרע',
  'admins.status.approved': 'אושר',
  'admins.status.declined': 'נדחה',
  'admins.status.withdrawn': 'בוטל',
  'admins.status.open': 'פתוח',
  'admins.byMajority': 'רוב המנהלים אישרו',
  'admins.byTimeout': 'אף אחד לא התנגד בזמן',
  'admins.rules': 'איך המשפחה מחליטה',
  'admins.rulesHelp': 'שנו את אלה רק יחד עם שאר המנהלים. הם מה שמונע מחודש שקט להקפיא את המשפחה — ומה שמונע מאדם אחד להחליט לבד.',
  'admins.activeDays': 'מנהל/ת נספר/ת לרוב אם היה/הייתה פעיל/ה בתוך',
  'admins.timeoutDays': 'הצעה ללא התנגדות עוברת אחרי',
  'admins.vouchTitle': 'אישור בני משפחה חדשים',
  'admins.vouchUnit': 'קרובים צריכים לאשר שהם מכירים אותם',
  'admins.vouchHelp': 'אדם שנוסף מופיע בעמעום בעץ עד שמספר כזה של קרובים יאשרו שהם מכירים אותו — מי שהוסיף אותו נספר כראשון. כל מנהל יכול לאשר מיד, או לשנות את המספר הזה.',
  'admins.vouchFewer': 'פחות קרובים',
  'admins.vouchMore': 'יותר קרובים',
  'admins.error.email': 'זו לא נראית כתובת אימייל.',
  'admins.error.already': 'הם כבר מנהלים.',
  'admins.error.openAlready': 'כבר יש הצעה פתוחה לכתובת הזו.',
  'admins.error.closed': 'ההצעה הזו כבר הוכרעה.',

  // ---- החלטות המנהלים ----
  'decisions.help': 'כל מה שנעשה בסמכות ניהול, כדי שכל מנהל יוכל לראות מי עשה מה ומתי.',
  'decisions.by': '{name} · {when}',
  'decisions.empty': 'אף מנהל עוד לא עשה דבר.',
  'decisions.removals': 'תמונות שהוסרו',
  'decisions.reason': 'הסיבה: {reason}',
  'decisions.noReason': 'לא נמסרה סיבה.',
  'decisions.reasonLabel': 'סיבה (לא חובה)',
  'decisions.reasonPlaceholder': 'אפשר להסביר, אם זה יעזור למשפחה להבין',
  'decisions.reasonHelp': 'מה שתכתבו נשמר עם ההחלטה וכל המנהלים יכולים לקרוא.',
  'decisions.removePicture': 'להסיר תמונה',
  'decisions.removePictureHelp': 'היא תפסיק להופיע למשפחה. התמונה נשמרת כאן, כדי שאפשר יהיה לראות את ההחלטה ולבטל אותה.',
  'decisions.removed': 'הוסרה. היא נמצאת בהחלטות מנהלים.',
  'decisions.putBack': 'להחזיר',
  'decisions.restored': 'חזרה למקומה.',
  'audit.bySystem': 'האפליקציה',
  'audit.action.remove': 'הוסר',

  // ---- זיהוי בן משפחה חדש ----
  'recognise.waiting': 'ממתינים לעוד {n} מהמשפחה שיאשרו שהם מכירים אותם.',
  'recognise.waitingAny': 'ממתינים שהמשפחה תזהה אותם.',
  'recognise.vouch': 'אני מכיר/ה אותם',
  'recognise.mine': 'אמרת שאת/ה מכיר/ה אותם',
  'recognise.thanks': 'תודה — נרשם.',
  'recognise.approveNow': 'לאשר עכשיו',
  'recognise.done': '{name} חלק מעץ המשפחה.',

  // ---- הוספת בן משפחה ----
  'add.relatedTo': 'למי הם קשורים?',
  'add.relatedToPlaceholder': 'חיפוש במשפחה',
  'add.inviteEmail': 'האימייל שלהם (לא חובה)',
  'add.inviteEmailPlaceholder': 'name@example.com',
  'add.inviteEmailHelp': 'נשלח להם הזמנה להצטרף למשפחה. אם תשאירו ריק, לא יישלח דבר.',
  'add.recogniseNote': 'הם מצטרפים לעץ מיד, ומופיעים בעמעום עד שמספיק בני משפחה יאשרו שהם מכירים אותם. כל מנהל יכול לאשר מיד.',
  'add.doneInvited': '{name} נוסף/ה, והזמנה בדרך אל {email}.',
  'add.doneWaiting': '{name} נוסף/ה — ממתינים ל-{n} מהמשפחה שיאשרו שהם מכירים אותם.',
  'add.invite.badEmail': 'זו לא נראית כתובת אימייל.',

  // ---- מה שפרסמו ומה שהם מופיעים בו ----
  'latest.filter': 'להציג',
  'latest.filter.stories': 'סיפורים',
  'latest.filter.pictures': 'תמונות',

  'common.days': '{n} ימים',
  'common.save': 'שמירה',
  // ---- מי אחראי על עיגול ----
  'portrait.adminChange': 'לשנות את התמונה (ניהול)',
  'profile.editAsAdmin': 'לערוך פרטים (ניהול)',
  'edit.ownerOnly': 'רק מי שאחראי על העיגול הזה יכול לשנות את הפרטים שלו. מנהל יכול לשנות של כל אחד.',
  'tree.unclaimed': 'עוד אף אחד לא התחבר בתור האדם הזה',
  'tree.legend.memorial': 'ז״ל: אדם שנפטר, זכרונו/ה לברכה',
  'tree.legend.unclaimed': 'דמות מקווקוות: עוד אף אחד לא התחבר בתור האדם הזה',
  'owner.by': 'באחריות {name}',
  'owner.you': 'את/ה אחראי/ת על העיגול הזה',
  'owner.yourOwn': 'זה העיגול שלך',
  'owner.themselves': '{name} אחראי/ת על העיגול הזה',
  'owner.helpers': 'מנוהל גם על ידי {names}',
  'owner.nobody': 'עוד אף אחד לא אחראי על העיגול הזה',
  'owner.none': 'עוד אין אחראי',
  'owner.change': 'לשנות מי אחראי',
  'owner.changeHelp': 'רק מי שאחראי על עיגול — ומנהל — יכולים לשנות את התמונה והפרטים שלו. בחרו מי זה יהיה.',
  'owner.changed': 'בוצע.',
  'owner.clear': 'להשאיר בלי אחראי',
  'owner.claimedNote': 'הם שייכו את העיגול הזה לעצמם, והוא נשאר שלהם.',
  'owner.error.claimed': 'האדם הזה שייך את העיגול לעצמו. רק הוא יכול לשנות אותו.',

  // ---- הסרת עיגול בהסכמת המנהלים ----
  'removal.propose': 'להציע הסרה',
  'removal.proposeHelp': 'העיגול יוסר מהעץ רק אחרי שהמנהלים האחרים יסכימו. שום דבר לא נמחק — האדם, הסיפורים והסיבה נשמרים, ואפשר להחזיר.',
  'removal.proposed': 'ההצעה נשלחה. שאר המנהלים קיבלו הודעה.',
  'removal.proposedBy': 'הוצע על ידי {name}',
  'removal.pending': 'ממתינים להסכמת המנהלים להסרת העיגול — {yes} מתוך {needed}.',
  'removal.agree': 'להסכים להסרה',
  'removal.autoIn': 'אף אחד לא התנגד — זה יקרה בעוד {days} ימים אם זה יישאר כך.',
  'removal.objectHelp': 'התנגדות עוצרת את ההסרה האוטומטית. היא עדיין יכולה לקרות ברוב.',
  'removal.error.self': 'אי אפשר להציע להסיר את העיגול של עצמך.',
  'removal.error.openAlready': 'כבר יש הצעה פתוחה לעיגול הזה.',

  // ---- העוזר: כפתור העזרה בכל מסך ----
  'assistant.title': 'עזרה',
  'assistant.open': 'עזרה',
  'assistant.greeting': 'במה אפשר לעזור?',
  'assistant.placeholder': 'שאלו אותי כל דבר',
  'assistant.send': 'לשאול',
  'assistant.unsure': 'אני לא בטוח לגבי זה.',
  'assistant.showing': 'מראה לכם איפה ללחוץ',
  'assistant.gotIt': 'הבנתי',
  'assistant.cantShow': 'אני לא רואה את הכפתור הזה מכאן.',
  'assistant.lookFor': 'חפשו את {what} — {where}.',
  'assistant.pressLit': 'לחצו על הכפתור המואר.',
  'assistant.by.local': 'מובנה',
  'assistant.by.anthropic': 'Claude',
  'assistant.by.openai': 'OpenAI',
  'assistant.by.proxy': 'השרת שלכם',
  'assistant.age.some': 'בערך בגילכם: {who}.',
  'assistant.age.more': ' ועוד {n}',
  'assistant.age.none': 'לאף אחד אחר במשפחה אין שנת לידה קרובה לשלכם.',
  'assistant.age.noMe': 'אני לא יודע מי אתם בעץ, אז אי אפשר להשוות גילים. אפשר להתחבר לעיגול שלכם דרך הפרופיל.',
  'assistant.age.noYear': 'שנת הלידה שלכם לא רשומה, אז אין למה להשוות.',
  'assistant.stopWalk': 'מספיק, תודה',
  'assistant.mode.simple': 'פשוט',
  'assistant.limit.prototype': 'החלק הזה עוד לא נבנה.',
  'assistant.limit.design': 'זה בכוונה, לא תקלה.',
  'assistant.offerReport': 'אני לא יכול לתקן את זה, אבל אני יכול לספר למנהלי המשפחה.',
  'assistant.did.went': 'לקחתי אתכם ל{screen}',
  'assistant.did.opened': 'פתחתי את {what}',
  'assistant.did.filled': 'מילאתי — בדקו ולחצו שמירה',
  'assistant.did.mode': 'עברתי למצב {mode}',
  'assistant.did.lang': 'החלפתי שפה',
  'assistant.did.showedOnTree': 'הראיתי לך את {name} בעץ',
  'assistant.did.showedOnGlobe': 'הראיתי לך איפה {name} נמצאים',
  'assistant.did.showedOnTimeline': 'סיננתי את ציר הזמן ל{name}',
  'assistant.did.showedOnCalendar': 'מצאתי את {name} בלוח השנה',
  'assistant.did.showedDay': 'פתחתי את לוח השנה ב־{day}',

  // קול
  'assistant.tapToTalk': 'לוחצים ושואלים',
  'assistant.orHold': 'או להחזיק בזמן הדיבור',
  'assistant.letGo': 'לשחרר כשסיימתם',
  'assistant.working': 'רק רגע…',
  'assistant.stopAll': 'עצירה וסגירה',
  'assistant.tapToStop': 'לוחצים כשסיימתם',
  'assistant.askAgain': 'לשאול משהו אחר',
  'assistant.useKeyboard': 'להקליד במקום',
  'assistant.useVoice': 'לדבר במקום',
  'assistant.listening': 'מקשיב…',
  'assistant.voice.denied': 'לא ניתנה גישה למיקרופון. אפשר לאשר אותה בדפדפן.',
  'assistant.voice.noMic': 'לא מצאתי מיקרופון.',
  'assistant.voice.failed': 'ההקשבה לא עבדה. אפשר להקליד במקום.',

  // לספר למנהלים
  'assistant.report.kind.fault': 'משהו לא עובד',
  'assistant.report.kind.idea': 'רעיון לאפליקציה',
  'assistant.report.kind.question': 'שאלה למנהלים',
  'assistant.report.titleHint': 'בכמה מילים, מה קרה?',
  'assistant.report.attached': 'איפה אתם ומה עשיתם מצורף אוטומטית.',
  'assistant.report.send': 'לשלוח',
  'assistant.report.sent': 'נשלח. מנהלי המשפחה רואים את זה.',
  'assistant.report.needTitle': 'ספרו לי בכמה מילים מה קרה.',

  // כשאי אפשר לענות
  'assistant.error.key': 'המפתח של העוזר לא התקבל. מנהל יכול לבדוק אותו בבקרות המנהל.',
  'assistant.error.rate': 'יותר מדי שאלות בבת אחת. נסו שוב עוד רגע.',
  'assistant.error.network': 'לא הצלחתי להגיע לעוזר. בדקו את החיבור.',
  'assistant.error.server': 'לעוזר יש קושי כרגע. נסו שוב בקרוב.',
  'assistant.error.unknown': 'משהו השתבש בשאלה הזאת.',
  'assistant.error.noKey': 'העוזר עוד לא הוגדר. מנהל יכול לעשות זאת בבקרות המנהל.',
  'assistant.error.noUrl': 'לעוזר אין כתובת לפנות אליה. מנהל יכול להגדיר אותה בבקרות המנהל.',

  // הגדרות ← העוזר
  'settings.assistant': 'כפתור העזרה',
  'settings.assistant.listen': 'לאפשר לי לדבר במקום להקליד',
  'settings.assistant.listenHelp': 'מציג מיקרופון בחלון העזרה, כדי שתוכלו לומר מה אתם צריכים.',
  'settings.assistant.speak': 'להקריא תשובות בקול',
  'settings.assistant.speakHelp': 'כל תשובה נאמרת וגם מוצגת.',
  'settings.assistant.off': 'הקול כבוי למשפחה הזאת. מנהל יכול להפעיל אותו.',

  // בקרות מנהל ← מהמשפחה
  'manage.section.reports': 'מהמשפחה',
  'reports.title': 'תקלות, רעיונות ושאלות',
  'reports.help': 'נשלח מכפתור העזרה. המקום שבו האדם עמד מצורף — המסך, המצב, האם היה מנותק, ומה השתבש לאחרונה.',
  'reports.empty': 'אין עדיין כלום.',
  'reports.from': 'מאת {name}',
  'reports.filter.all': 'הכול',
  'reports.kind.fault': 'לא עובד',
  'reports.kind.idea': 'רעיון',
  'reports.kind.question': 'שאלה',
  'reports.status.new': 'חדש',
  'reports.status.seen': 'נקרא',
  'reports.status.planned': 'מתוכנן',
  'reports.status.done': 'בוצע',
  'reports.status.declined': 'לא נעשה',
  'reports.context': 'איפה הם היו',
  'reports.context.screen': 'מסך',
  'reports.context.mode': 'מצב',
  'reports.context.role': 'תפקיד',
  'reports.context.online': 'חיבור',
  'reports.context.online.yes': 'מחובר',
  'reports.context.online.no': 'מנותק',
  'reports.context.pending': 'ממתין לשליחה',
  'reports.context.lastError': 'השגיאה האחרונה על המסך',
  'reports.context.browser': 'דפדפן',
  'reports.context.assistant': 'עוזר',
  'reports.conversation': 'מה הם שאלו',
  'reports.answer': 'לענות להם',
  'reports.answerHint': 'הם יראו את זה בהתראות שלהם.',
  'reports.answerSend': 'לשלוח את התשובה',
  'reports.answered': 'נענה {when}',
  'reports.saved': 'נשמר.',

  // בקרות מנהל ← העוזר
  'manage.section.assistant': 'העוזר',
  'assistantAdmin.title': 'מי עונה לכפתור העזרה',
  'assistantAdmin.help': 'העוזר עובד בלי שום הגדרה — הוא מכיר את האפליקציה ויכול להוליך כל אחד דרכה. הוספת מודל מאפשרת לו לענות במילים שלו ולהבין שאלות שלא לימדו אותו.',
  'assistantAdmin.provider': 'מי עונה',
  'assistantAdmin.provider.local': 'מובנה (בלי הגדרה)',
  'assistantAdmin.provider.local.help': 'עונה על השאלות הנפוצות ומראה איפה ללחוץ. לא צריך מפתח, עובד בלי חיבור, ושום דבר לא יוצא מהמכשיר.',
  'assistantAdmin.provider.anthropic': 'קלוד',
  'assistantAdmin.provider.openai': 'OpenAI, או כל דבר שמדבר בשפה שלה',
  'assistantAdmin.provider.openai.help': 'עובד גם עם Groq,‏ Together ו‑OpenRouter — וגם עם מודל על המחשב שלכם דרך Ollama או LM Studio, שלא צריך מפתח בכלל.',
  'assistantAdmin.provider.proxy': 'כתובת משלכם',
  'assistantAdmin.provider.proxy.help': 'האפליקציה שולחת את השאלה לכתובת שאתם מפעילים, והשרת שלכם מחזיק את המפתח. בזה כדאי להשתמש ברגע שיש שרת.',
  'assistantAdmin.model': 'מודל',
  'assistantAdmin.modelHint': 'להשאיר ריק עבור {model}',
  'assistantAdmin.key': 'מפתח',
  'assistantAdmin.keyHint': 'נשמר לכל המשפחה — מגדירים כאן פעם אחת ואף אחד אחר לא צריך.',
  'assistantAdmin.url': 'כתובת',
  'assistantAdmin.urlHint': 'הכתובת המלאה שאליה נשלחת השאלה.',
  'assistantAdmin.urlOptional': 'כתובת (לא חובה)',
  'assistantAdmin.urlOptionalHint': 'למודל על המחשב שלכם, למשל http://localhost:11434/v1. להשאיר ריק לכתובת הרגילה.',
  'assistantAdmin.keyWarning': 'מפתח שנשמר כאן ניתן לקריאה בדפדפן של כל בן משפחה מחובר, כי כל דפדפן צריך לבצע את הקריאה. זה בסדר לניסוי עם המשפחה. כשיש כסף אמיתי על המפתח, עדיף כתובת משלכם כך שהוא יישאר על שרת.',
  'assistantAdmin.test': 'לבדוק',
  'assistantAdmin.testing': 'בודק…',
  'assistantAdmin.hear': 'להשמיע',
  'assistantAdmin.hearing': 'מדבר…',
  'assistantAdmin.hearLine': 'שלום — זה הקול שהמשפחה תשמע.',
  'assistantAdmin.heardOk': 'זה הקול. הוא עובד.',
  'assistantAdmin.heardFailed': 'לא הצליח לדבר. בדקו את המפתח ואת שם הקול למעלה.',
  'assistantAdmin.log': 'מה העוזר עשה',
  'assistantAdmin.logHelp': 'הקריאות האחרונות שביצע — שימושי כשתשובה או קול לא מגיעים וצריך לראות למה.',
  'assistantAdmin.logCopy': 'העתקת היומן',
  'assistantAdmin.logCopied': 'הועתק',
  'assistantAdmin.logClear': 'ניקוי',
  'assistantAdmin.logEmpty': 'עדיין כלום. שאלו את העוזר משהו, או לחצו להשמיע.',
  'assistantAdmin.testOk': 'הוא ענה. העוזר עובד.',
  'assistantAdmin.testFailed': 'אין תשובה: {why}',
  'assistantAdmin.why.credit': 'המפתח תקין, אבל אין יתרה בחשבון שלו. צריך לקנות קרדיט בקונסולה של Claude — מפתח ויתרה הם שני דברים נפרדים, ומפתח חדש מתחיל בלי יתרה.',
  'assistantAdmin.why.model': 'אין דגם בשם הזה, או שלמפתח הזה אין גישה אליו. אפשר לרוקן את שדה הדגם כדי לחזור אל {model}.',
  'assistantAdmin.why.blocked': 'הבקשה לא יצאה מהדפדפן בכלל. בדרך כלל אין אינטרנט, תוסף חוסם, או שהכתובת שגויה.',
  'assistantAdmin.why.key': 'המפתח עצמו נדחה. כדאי להעתיק אותו שוב מהקונסולה — זו שורה אחת ארוכה שמתחילה ב־sk-ant-, בלי רווחים ובלי מעברי שורה.',
  'assistantAdmin.why.serverKey': 'המפתח שעל השרת נדחה. בדקו את OPENAI_API_KEY (או ANTHROPIC_API_KEY, למודל של Claude) בקובץ ‎.env או בהגדרות האחסון, והפעילו את האפליקציה מחדש.',
  'assistantAdmin.server.answer': 'עונה: {name} ‏({model}). המפתח שמור על השרת, כך שאף אחד במשפחה לא צריך להגדיר שום דבר, בשום מכשיר.',
  'assistantAdmin.server.keys': 'את המודלים אפשר לבחור כאן. את המפתחות לא: הם נמצאים בקובץ ‎.env במחשב שמריץ את האפליקציה — או בהגדרות האחסון — וכדי להחליף מפתח עורכים אותו שם ומפעילים מחדש.',
  'assistantAdmin.server.default': 'ברירת המחדל של השרת ({model})',
  'assistantAdmin.server.unavailable': '{model} — לא זמין עם המפתחות האלה, ולכן משתמשים בברירת המחדל',
  'assistantAdmin.server.modelsLoading': 'טוען את המודלים שהמפתחות האלה יכולים להשתמש בהם…',
  'assistantAdmin.server.modelHelp': 'כל המודלים שהמפתחות האלה יכולים להשתמש בהם. מודלים קטנים (mini,‏ nano,‏ haiku) עונים מהר יותר ועולים פחות; גדולים מבינים שאלות קשות יותר.',
  'assistantAdmin.server.effort': 'כמה זמן הוא חושב לפני שהוא עונה',
  'assistantAdmin.server.effort.quick': 'הכי מהר',
  'assistantAdmin.server.effort.balanced': 'מאוזן',
  'assistantAdmin.server.effort.careful': 'הכי יסודי',
  'assistantAdmin.server.effortHelp': 'מחכים לכל תשובה בקול, ולכן "הכי מהר" מתאים בדרך כלל. "הכי יסודי" יכול להוסיף כמה שניות לפני שנאמר משהו.',
  'assistantAdmin.server.listenModel': 'מודל ההקשבה',
  'assistantAdmin.server.speakModel': 'מודל הקול',
  'assistantAdmin.server.speechify': 'Speechify (אנגלית; עברית נשארת עם OpenAI)',
  'assistantAdmin.listening': 'מי מקשיב',
  'assistantAdmin.listen.off': 'כבוי',
  'assistantAdmin.listen.browser': 'של הדפדפן',
  'assistantAdmin.listen.browser.help': 'חינם, פרטי, ועובד בעברית. רק ב‑Chrome וב‑Safari, ומראה את המילים תוך כדי הדיבור.',
  'assistantAdmin.listen.openai': 'OpenAI Whisper',
  'assistantAdmin.listen.openai.help': 'טוב מהדפדפן בעברית ובקול מבוגר. ההקלטה נשלחת בסיום, כך שהמילים מופיעות בסוף ולא תוך כדי.',
  'assistantAdmin.listen.proxy': 'כתובת משלכם',
  'assistantAdmin.listen.proxy.help': 'שולח את ההקלטה ל‑/transcribe בכתובת שלמטה ומצפה ל‑{"text": "…"} בחזרה.',
  'assistantAdmin.listen.server': 'תמיד השרת',
  'assistantAdmin.listen.server.help': 'כל שאלה מוקלטת ונשלחת לשרת (OpenAI). טוב יותר עם עברית ועם קול מבוגר, אבל המילים מופיעות כשמסיימים לדבר ולא תוך כדי.',
  'assistantAdmin.listen.browser.serverHelp': 'הדפדפן מקשיב ומציג את המילים תוך כדי דיבור — הדרך המהירה ביותר. בטלפון או בדפדפן שלא יכולים, השרת מקשיב במקומם.',

  'assistantAdmin.speaking': 'מי מדבר',
  'assistantAdmin.speakingHelp': 'העוזר מקריא כל תשובה בקול, אז זה החלק שהכי כדאי לדייק בו.',
  'assistantAdmin.speak.off': 'כבוי',
  'assistantAdmin.speak.browser': 'של הדפדפן',
  'assistantAdmin.speak.browser.help': 'חינם ותמיד זמין, אבל פשוט, והעברית חלשה ברוב המכשירים.',
  'assistantAdmin.speak.speechify': 'Speechify',
  'assistantAdmin.speak.speechify.help': 'קולות חמים וטבעיים בשפות רבות — הנעים ביותר להאזנה. דיבור בלבד; ההקשבה נעשית במקום אחר.',
  'assistantAdmin.speak.speechify.where': 'מתוך platform.speechify.ai ← API keys.',
  'assistantAdmin.speak.openai': 'OpenAI',
  'assistantAdmin.speak.openai.help': 'קולות טובים, ואותו מפתח כמו Whisper אם כבר משתמשים בו.',
  'assistantAdmin.speak.proxy': 'כתובת משלכם',
  'assistantAdmin.speak.proxy.help': 'מבקש אודיו מ‑/speak בכתובת שלמטה, כך שהמפתח נשאר על השרת שלכם.',
  'assistantAdmin.speak.server': 'השרת ({name})',
  'assistantAdmin.speak.server.help': 'קול טבעי, והמפתח שלו שמור על השרת. התשובות מושמעות משפט אחרי משפט, כך שהמילים הראשונות מגיעות מהר.',
  'assistantAdmin.speak.server.noHebrew': 'שום דבר על השרת לא מדבר עברית, ולכן תשובות בעברית מושמעות בקול של הדפדפן. הוסיפו OPENAI_API_KEY לשרת בשביל קול עברי טבעי.',
  'assistantAdmin.speak.server.hebrewEnding': 'הקולות הנוכחיים של Speechify לא מדברים עברית. המודל הישן שלהם עוד מדבר בינתיים, אבל הוא נסגר בנובמבר 2026 — הוסיפו OPENAI_API_KEY לשרת כדי לשמור על קול עברי טבעי.',
  'assistantAdmin.speakFallback': 'אם אי אפשר להגיע לקול הזה — מפתח שפג, הגבלת קצב, או דפדפן שחוסם את הקריאה — העוזר חוזר לקול של הדפדפן במקום לשתוק.',
  'assistantAdmin.voiceNoList': 'אין עדיין קולות לבחירה. הוסיפו מפתח למעלה, או הקלידו שם של קול.',
  'assistantAdmin.voiceName': 'קול',
  'assistantAdmin.voiceDefault': 'מה שהמכשיר משתמש בו',
  'assistantAdmin.voiceServerDefault': 'קול ברירת המחדל של השרת',
  'assistantAdmin.cost': 'כמה עולה כל שאלה',
  'assistantAdmin.costHelp': 'האפליקציה מתארת את עצמה למודל בערך ב‑{tokens} מילות הנחיה. שום דבר על המשפחה לא נשלח אלא אם שאלה דורשת זאת, ואז רק כמה שורות.',
  'assistantAdmin.knows': 'מה הוא יודע',
  'assistantAdmin.knowsCounts': '{screens} מסכים · {controls} כפתורים שהוא יכול להצביע עליהם · {rules} כללים · {limits} מגבלות ידועות · {howtos} הדרכות',
  'assistantAdmin.autosaves': 'אין מה ללחוץ — השינויים נשמרים לכל המשפחה תוך כדי.',
  'assistantAdmin.saving': 'שומר…',
  'assistantAdmin.saveFailed': 'לא נשמר: {why}',
  'assistantAdmin.savedForFamily': 'נשמר לכולם',
  'assistantAdmin.saved': 'נשמר.',

  // ---- מתכונים ----
  'add.recipe': 'לכתוב מתכון',
  'add.recipeHelp': 'אומרים בקול, או מקלידים.',
  'recipe.one': 'מתכון',
  'recipe.add': 'לכתוב מתכון',
  'recipe.untitled': 'מתכון שעוד אין לו שם',
  'recipe.draft': 'טיוטה',
  'recipe.draft.onlyYou': 'רק אתם רואים את זה עד שתפרסמו.',
  'recipe.continue': 'להמשיך',
  'recipe.ingredients': 'מצרכים',
  'recipe.method': 'אופן ההכנה',
  'recipe.notes': 'הערות',
  'recipe.step': 'שלב',
  'recipe.step.done': 'את זה עשיתי',
  'recipe.step.undo': 'עוד לא',
  'recipe.byline.of': 'המתכון של {name}',
  'recipe.byline.writtenBy': 'נכתב על ידי {name}',
  'recipe.react': 'להגיב למתכון',
  'recipe.awake': 'להשאיר את המסך דולק',
  'recipe.awake.on': 'המסך נשאר דולק',
  'recipe.edit': 'עריכת המתכון',
  'recipe.editAsAdmin': 'עריכה כמנהל/ת',
  'recipe.changes.waiting': 'יש לכם שינויים במתכון הזה שהמשפחה עוד לא רואה.',
  'recipe.changes.note': 'המשפחה עדיין רואה את המתכון כפי שהיה. השינויים שלכם ייצאו כשתלחצו «פרסום השינויים».',
  'recipe.studio.new': 'מתכון חדש',
  'recipe.studio.editing': 'עריכת מתכון',
  'recipe.status.saving': 'שומר…',
  'recipe.status.draft': 'נשמר — רק אתם רואים',
  'recipe.status.changes': 'נשמר — עוד לא פורסם',
  'recipe.status.published': 'פורסם',
  'recipe.status.failed': 'עוד לא נשמר',
  'recipe.publish': 'פרסום',
  'recipe.publishChanges': 'פרסום השינויים',
  'recipe.publishing': 'מפרסם…',
  'recipe.published': 'שותף עם המשפחה',
  'recipe.changesPublished': 'השינויים פורסמו',
  'recipe.keptAsDraft': 'נשמר כטיוטה — מחכה בעיגול של {name}',
  'recipe.tell.title': 'ספרו לי את המתכון',
  'recipe.tell.titleFor': 'ספרו לי את המתכון של {name}',
  'recipe.tell.help': 'בדיוק כמו שמספרים ליד השולחן במטבח — מה נכנס, כמה, ומה עושים. בכל סדר. אני אכתוב את זה כמו שצריך.',
  'recipe.tell.helpNoModel': 'בדיוק כמו שמספרים ליד השולחן במטבח. אין עוזר מחובר, אז המילים שלכם יסודרו כמו שהן, ואתם תלטשו.',
  'recipe.tell.typeHelp': 'מקלידים או מדביקים, גם אם זה לא מסודר.',
  'recipe.tell.typePlaceholder': 'מרק העוף של סבתא. עוף שלם, שלושה גזרים…',
  'recipe.tell.start': 'להתחיל לספר את המתכון',
  'recipe.tell.done': 'סיימתי',
  'recipe.tell.pressWhenDone': 'קחו את הזמן. לוחצים על ה־✓ כשמסיימים.',
  'recipe.tell.listening': 'מקשיב…',
  'recipe.tell.listeningBlind': 'מקשיב. המילים יופיעו כשתסיימו.',
  'recipe.tell.reading': 'רק רגע…',
  'recipe.tell.useKeyboard': 'להקליד במקום',
  'recipe.tell.useVoice': 'לומר בקול במקום',
  'recipe.tell.startOver': 'להתחיל מחדש',
  'recipe.tell.writeUp': 'לכתוב את המתכון',
  'recipe.tell.layOut': 'לסדר את זה',
  'recipe.tell.asIs': 'להשתמש במילים שלי כמו שהן',
  'recipe.tell.heardNothing': 'לא נשמע כלום. לחצו על המיקרופון ונסו שוב — או הקלידו.',
  'recipe.tell.stopped': 'המיקרופון נעצר מעצמו. זה מה שנשמע — הוסיפו מה שחסר ולחצו «לכתוב את המתכון».',
  'recipe.tell.noRecipe': 'לא היה בזה מתכון. אמרו מה המנה, מה נכנס בה ומה עושים.',
  'recipe.writing.title': 'כותב את המתכון שלכם…',
  'recipe.writing.help': 'מפריד בין מה שנכנס לבין מה שעושים. שום דבר לא מתווסף למה שאמרתם.',
  'recipe.change.hint': 'אמרו מה לשנות — «בשורה 5 צריך להיות שתי כוסות סוכר». או הקישו על כל שורה.',
  'recipe.change.hintType': 'כתבו מה לשנות — «בשורה 5 צריך להיות שתי כוסות סוכר». או הקישו על כל שורה.',
  'recipe.change.hintNoModel': 'הקישו על כל שורה כדי לשנות אותה.',
  'recipe.change.start': 'לומר מה לשנות',
  'recipe.change.send': 'שליחה',
  'recipe.change.type': 'לכתוב מה לשנות',
  'recipe.change.placeholder': 'בשורה 5 צריך להיות שתי כוסות סוכר',
  'recipe.change.listening': 'מקשיב — מה לשנות?',
  'recipe.change.thinking': 'משנה…',
  'recipe.ai.changed': 'בוצע — השורות המוארות הן מה שהשתנה.',
  'recipe.ai.unchanged': 'שום דבר לא השתנה. נסו לומר איזו שורה, ומה צריך להיות כתוב בה.',
  'recipe.ai.laidOut': 'המילים שלכם, מסודרות כמו שהן. הקישו על כל שורה כדי ללטש.',
  'recipe.ai.noModel': 'אין עוזר מחובר, אז המילים שלכם סודרו כמו שהן. הקישו על כל שורה כדי ללטש.',
  'recipe.undo': 'לבטל את השינוי האחרון',
  'recipe.line.label': 'שורה {n}: {text}',
  'recipe.line.remove': 'להסיר את השורה',
  'recipe.add.intro': 'משפט על המנה',
  'recipe.add.fact': 'כמה מנות, כמה זמן…',
  'recipe.add.ingredient': 'להוסיף מצרך',
  'recipe.add.step': 'להוסיף שלב',
  'recipe.add.note': 'להוסיף הערה',
  'recipe.placeholder.title': 'שם המנה',
  'recipe.placeholder.intro': 'של מי המנה, מתי מכינים אותה…',
  'recipe.placeholder.fact': '6 מנות',
  'recipe.placeholder.ingredient': '2 כוסות קמח  (נקודתיים בסוף = כותרת)',
  'recipe.placeholder.step': 'מה עושים עכשיו',
  'recipe.placeholder.note': 'טיפ, גרסה אחרת, איך שומרים',
  'recipe.who.ask': 'של מי המתכון?',
  'recipe.who.help': 'הוא ייתלה על העיגול שלהם בעץ. בחרו את עצמכם, או את מי שאת המתכון שלו אתם כותבים.',
  'recipe.who.change': 'לשנות',
  'recipe.photo.failed': 'לא הצלחנו להוסיף את התמונה הזו.',
  // התמונות שלו. כל אחד במשפחה יכול להוסיף; הראשונה מייצגת את המתכון עד שבוחרים אחרת.
  'recipe.pictures': 'תמונות',
  'recipe.pictures.invite': 'הכנתם? הוסיפו תמונה — כל המשפחה תראה.',
  'recipe.pictures.add': 'הוספת תמונה',
  'recipe.pictures.addFirst': 'הוספת תמונה של המנה',
  'recipe.pictures.adding': 'מוסיף…',
  'recipe.pictures.added': 'התמונה נוספה',
  'recipe.pictures.addedMany': 'נוספו {n} תמונות',
  'recipe.pictures.onlyPictures': 'אפשר להוסיף למתכון רק תמונות.',
  'recipe.pictures.pasteHint': 'אפשר גם להעתיק תמונה ולהדביק אותה כאן (Ctrl+V).',
  'recipe.pictures.open': 'תמונה {n}',
  'recipe.pictures.openMain': 'פתיחת התמונה',
  'recipe.pictures.main': 'התמונה הראשית',
  'recipe.pictures.makeMain': 'להפוך לתמונה הראשית',
  'recipe.pictures.madeMain': 'זו עכשיו התמונה הראשית של המתכון',
  'recipe.deleteDraft': 'למחוק את הטיוטה',
  'recipe.deleteDraft.body': 'אף אחד אחר לא ראה אותה, אז היא פשוט תיעלם.',
  'recipe.discardChanges': 'לבטל את השינויים שלי',
  'recipe.discardChanges.body': 'המתכון חוזר להיות כפי שהמשפחה רואה אותו עכשיו.',
  'recipe.takeDown': 'להוריד את המתכון',
  'recipe.takeDown.body': 'המשפחה לא תראה אותו יותר. הוא נשמר, ומנהל/ת יכול/ה להחזיר אותו.',
  'recipe.draftDeleted': 'הטיוטה נמחקה',
  'recipe.changesDiscarded': 'השינויים בוטלו',
  'recipe.takenDown': 'המתכון הורד',
  'recipe.clash.title': 'המתכון הזה השתנה במקום אחר',
  'recipe.clash.body': 'במכשיר אחר, או על ידי מישהו אחר שמורשה לערוך אותו. איזו גרסה לשמור?',
  'recipe.clash.mine': 'לשמור את שלי',
  'recipe.clash.theirs': 'להשתמש בשנייה',
  'recipe.error.notFound': 'המתכון הזה כבר לא כאן.',
  'recipe.error.needTitle': 'קודם תנו למנה שם.',
  'recipe.error.needBody': 'קודם הוסיפו לפחות מצרך אחד או שלב אחד.',
  'recipe.error.needPerson': 'קודם בחרו של מי המתכון.',
  'recipe.error.notYours': 'רק מי שכתב את המתכון, מי שהמתכון שלו, או מנהל/ת יכולים לשנות אותו.',

  // ---- מדור לדור: המדף של מה שהמשפחה מעבירה הלאה (היום מתכונים; בהמשך סוגים נוספים) ----
  'passed.search': 'חיפוש במה שעבר מדור לדור',
  'passed.search.hint': 'חיפוש — מנה, מרכיב, שם',
  'passed.search.clear': 'ניקוי החיפוש',
  'passed.kinds': 'הצגת סוג אחד',
  'passed.kind.recipes': 'מתכונים',
  'passed.found': 'נמצאו {count}',
  'passed.showAll': 'הצגת הכול',
  'passed.none': 'לא נמצא דבר מתאים. נסו מילה אחרת, או הציגו הכול.',
  'passed.empty.title': 'עוד לא הועבר כאן דבר',
  'passed.empty.help': 'התחילו במתכון שכולם מבקשים: לוחצים על ה־+ בתחתית ובוחרים «לכתוב מתכון». אמרו אותו בקול והוא ייכתב בשבילכם — ומאותו רגע הוא של כל המשפחה, לתמיד.',

  // ---- הודעת הפתיחה: הלוח שכולם קוראים פעם אחת, ושוב כשהוא משתנה (domain/welcome.ts) ----
  'greeting.menu': 'הודעת הפתיחה',
  'issue.menu': 'דיווח על בעיה',
  'issue.title': 'דיווח על בעיה או רעיון',
  'issue.kind': 'במה מדובר?',
  'issue.kind.fault': 'משהו לא עובד',
  'issue.kind.idea': 'רעיון',
  'issue.kind.question': 'שאלה',
  'issue.what': 'בשורה אחת',
  'issue.what.placeholder.fault': 'למשל: התמונה לא נשמרה',
  'issue.what.placeholder.idea': 'למשל: להציג ימי הולדת על העץ',
  'issue.what.placeholder.question': 'למשל: איך מוסיפים את סבתא?',
  'issue.detail': 'פרטים נוספים (לא חובה)',
  'issue.detail.placeholder': 'מה עשית, ומה קרה?',
  'issue.help': 'המסך שבו את/ה נמצא/ת והמכשיר נשלחים יחד עם הדיווח, כך שאין צורך להסביר.',
  'issue.send': 'שליחה',
  'issue.sending': 'שולח…',
  'issue.close': 'סגירה',
  'issue.thanks': 'תודה — המנהלים קיבלו את זה.',
  'issue.thanksGithub': 'תודה — זה אצל המנהלים ואצל המפתחים (#{n}).',
  'issue.error': 'לא הצלחנו לשלוח. כדאי לבדוק את החיבור ולנסות שוב.',
  'greeting.continue': 'להמשיך',
  'greeting.changedNote': 'ההודעה השתנתה מאז שקראתם אותה.',
  'greeting.previewNote': 'תצוגה מקדימה — רק אתם רואים את זה.',
  // דברי הפתיחה של האפליקציה עצמה, עד שמנהל כותב אחרים. שורה ריקה פותחת פסקה חדשה.
  'greeting.default': 'זה המקום של המשפחה שלנו — האנשים, הסיפורים והמתכונים שלנו, שמורים יחד כדי ששום דבר לא יאבד.\n\nמתחילים בעץ: מקישים על העיגול של כל אחד כדי לראות את התמונות שלו, לשמוע את הסיפורים שלו ולמצוא את המתכונים שלו.\n\nה־+ בתחתית הוא הדרך להוסיף משהו משלכם — תמונה, סיפור שמספרים בקול, מתכון שכולם מבקשים.\n\nאם לא בטוחים מה לעשות, לוחצים על המיקרופון בפינה ושואלים. הוא עונה במילים פשוטות ויכול להראות איפה ללחוץ.\n\nכל מה שכאן פרטי למשפחה.',
  'greeting.error.empty': 'כתבו קודם משהו, לפחות בשפה אחת.',
  'manage.section.welcome': 'הודעת הפתיחה',
  'greeting.admin.help': 'זה מה שכל אחד קורא בפעם הראשונה שהוא פותח את האפליקציה. כששומרים שינוי, ההודעה עולה שוב פעם אחת לכולם — כך שזו גם דרך לומר משהו לכל המשפחה. כל אחד יכול לקרוא אותה שוב מהתפריט.',
  'greeting.admin.en': 'באנגלית',
  'greeting.admin.he': 'בעברית',
  'greeting.admin.preview': 'לראות איך זה נראה',
  'greeting.admin.oneIsEnough': 'מספיקה שפה אחת: מי שקורא בשפה השנייה יראה את זו במקומה. שורה ריקה פותחת פסקה חדשה.',
  'greeting.admin.onlyEn': 'רק האנגלית השתנתה. מי שקורא עברית עדיין יראה את הנוסח העברי — שנו גם אותו, או רוקנו אותו והם יקראו את האנגלית.',
  'greeting.admin.onlyHe': 'רק העברית השתנתה. מי שקורא אנגלית עדיין יראה את הנוסח האנגלי — שנו גם אותו, או רוקנו אותו והם יקראו את העברית.',
  'greeting.admin.save': 'שמירה לכולם',
  'greeting.admin.saved': 'נשמר. כולם יראו את הודעת הפתיחה החדשה בפעם הבאה שיפתחו את האפליקציה.',
  'greeting.admin.willShow': 'כשתשמרו, ההודעה תוצג שוב פעם אחת לכל המשפחה.',
  'greeting.admin.changedBy': 'שונתה לאחרונה על ידי {name} · {when}',
  'greeting.admin.builtIn': 'המשפחה קוראת את דברי הפתיחה של האפליקציה עצמה. אף אחד עוד לא שינה אותם.',
  'greeting.admin.original': 'להחזיר את הנוסח המקורי',

  // ---- Admin controls: a menu, and a page for each thing in it (features/admin/sections.ts) ----
  'manage.helpEditor': 'מה שהמשפחה ביקשה לשנות, מה שדיווחו, ומי הוזמן. כל מה שנעשה כאן נשמר בהיסטוריה.',
  'manage.backToMenu': 'חזרה אל {title}',
  'manage.waiting': '{n} ממתינים',
  'manage.group.todo': 'ממתין לכם',
  'manage.group.access': 'מי נכנס',
  'manage.group.care': 'שמירה על מה שכבר כאן',
  'manage.group.family': 'לכל המשפחה',
  'manage.group.prototype': 'אב-טיפוס',
  'manage.section.people': 'אנשים חדשים ועיגולים',
  'manage.about.review': 'לאשר, לדחות או לשאול על שינויים שהתבקשו.',
  'manage.about.people': 'לאשר מצטרפים חדשים; להסיר עיגול או להחזיר.',
  'manage.about.reports': 'תקלות, רעיונות ושאלות מכפתור העזרה.',
  'manage.about.duplicates': 'שני עיגולים שאולי הם אותו אדם.',
  'manage.about.jobs': 'הקלטות שלא הצליחו לעלות או להיות מגובות.',
  'manage.about.access': 'להזמין מישהו, והקודים שמכניסים אנשים.',
  'manage.about.admins': 'מי מנהל את המשפחה, והצבעות שמחכות לכם.',
  'manage.about.roles': 'מה כל חשבון רשאי לעשות, ומי עוזר למי.',
  'manage.about.moderation': 'לנעול, להוריד או להחזיר סיפור או מתכון.',
  'manage.about.locks': 'עיגולים ופרטים שמוגנים משינויים.',
  'manage.about.decisions': 'מה כל מנהל עשה, מתי ולמה.',
  'manage.about.audit': 'כל שינוי במשפחה, וביטול של שינוי.',
  'manage.about.welcome': 'מה שכולם קוראים בפעם הראשונה שהם נכנסים.',
  'manage.about.tree': 'איך עיגולים ותגים גדלים ונרגעים.',
  'manage.about.assistant': 'מי עונה לכפתור העזרה, ובאיזה קול.',
  'manage.about.prototype': 'הדמיה של ניתוק, תקלות ואנשים אחרים.',
  'manage.tree.save': 'שמירה',
  'manage.tree.unsaved': 'שינויים שלא נשמרו בתצוגת העץ',
  // ---- the review queue ----
  'review.empty': 'שום דבר לא ממתין לבדיקה.',
  'review.showSettled': 'להציג גם את {n} שכבר טופלו',
  'review.hideSettled': 'רק מה שממתין',
  'review.asked': 'נשלח. הם יראו את השאלה.',
  'review.askSend': 'שליחת השאלה',
  'review.askLabel': 'השאלה שלכם ל{name}',
  'review.rejectHelp': 'שום דבר בעץ לא משתנה. הם מקבלים הודעה, עם מה שתכתבו כאן.',
  // ---- possible duplicates ----
  'dup.adminOnly': 'רק מנהל יכול לאחד שני אנשים. אתם עדיין יכולים לסמן ששניים אינם אותו אדם.',
  'dup.empty': 'אין כרגע כפילויות אפשריות.',
  'dup.dismissed': 'נרשם — אלה שני אנשים שונים.',
  'dup.preview.nothing': 'לרשומה השנייה לא מחובר שום דבר נוסף, אז אין מה להעביר.',
  // ---- new people & circles ----
  'people.waiting': 'ממתינים להכרה',
  'people.waiting.none': 'אף אחד לא ממתין. כל מי שבעץ כבר הוכר.',
  'people.waiting.count': '{n} מתוך {needed} קרובים אמרו שהם מכירים אותם',
  'people.removal.title': 'הסרת עיגול',
  'people.removal.help': 'הוצאת עיגול מהעץ אינה החלטה של מנהל אחד כל עוד יש אחרים: נדרש רוב מבין המנהלים שהיו פעילים לאחרונה. שום דבר לא נמחק.',
  'people.removal.start': 'הצעה להסיר עיגול',
  'people.removal.who': 'העיגול של מי?',
  'people.removal.needs': 'כרגע נדרשים {n} מתוך {total} המנהלים שהיו פעילים לאחרונה. ההצעה עצמה נספרת כ«כן» שלכם.',
  'people.removal.alone': 'אתם המנהלים היחידים שהיו פעילים לאחרונה, ולכן זה יקרה מיד כשתציעו. אפשר להחזיר את העיגול מתוך «הוסרו מהעץ».',
  'people.removed': 'הוסרו מהעץ',
  'people.removed.when': 'הוסר {when}',
  'people.removed.back': '{name} חזר/ה לעץ.',
  'people.removed.putBack': 'להחזיר לעץ',
  'people.find': 'מישהו מסוים',
  'people.find.help': 'חפשו כל אחד כדי לשנות מי שומר על העיגול שלו, לערוך את הפרטים שלו, או להציע להסיר אותו.',
  'people.find.profile': 'פתיחת הפרופיל',
  // ---- invitations & codes ----
  'access.copy': 'העתקה',
  'access.copied': 'הועתק.',
  'access.copyFailed': 'ההעתקה לא הצליחה. לחצו לחיצה ארוכה על הקוד כדי להעתיק אותו בעצמכם.',
  'access.send': 'שליחה',
  'access.copyMessage': 'העתקת הודעה',
  'access.copiedMessage': 'הודעה עם הקוד הועתקה — הדביקו אותה אצלם.',
  'access.invites.created': 'ההזמנה מוכנה. שלחו להם את הקוד.',
  'access.temp.issued': 'קוד המכשיר מוכן.',
  'access.codes.created': 'קוד משפחתי חדש מוכן.',
  'access.revoked': 'בוטל. הוא כבר לא עובד.',
  'access.invites.codeLabel': 'קוד הזמנה',
  'access.temp.codeLabel': 'קוד מכשיר',
  'access.codes.codeLabel': 'קוד גישה משפחתי',
  'access.share.invite': '{name}, זו ההזמנה שלך לעץ המשפחה שלנו.\n\nפותחים את {url}\nבוחרים «{choice}» ומקלידים את הקוד:\n\n{code}',
  'access.share.temp': 'כדי לפתוח את עץ המשפחה שלנו ב־{device}:\n\nפותחים את {url}\nבוחרים «{choice}» ומקלידים את הקוד:\n\n{code}',
  'access.share.code': 'בואו להצטרף לעץ המשפחה שלנו.\n\nפותחים את {url}\nבוחרים «{choice}» ומקלידים את הקוד:\n\n{code}',
  'access.finished': 'נוצלו, פג תוקפם או בוטלו',
  'access.temp.redeemed': 'נוצל לראשונה {when}',
  'access.codes.create': 'יצירת קוד',
  'access.invites.formHelp': 'הזמנה שייכת לאדם אחד בעץ, עובדת פעם אחת, ותקפה ל־14 יום. כשמשתמשים בה, החשבון מתחבר לעיגול של אותו אדם.',
  'access.invites.destinationHelp': 'כתובת האימייל או מספר הטלפון שלהם. אפשר גם לשלוח להם את הקוד בעצמכם, אחרי שהוא נוצר.',
  'access.temp.formHelp': 'למי שאין לו אימייל ואין לו טלפון. הקוד מחבר מכשיר אחד בתור אותו אדם; אחר כך אפשר לבחור קוד PIN פשוט.',
  'access.temp.devicePlaceholder': 'הטאבלט בסלון',
  'access.codes.formHelp': 'קוד משפחתי רק פותח את הדלת — מי שמשתמש בו עדיין מתחבר בתור עצמו, ומבקש להתחבר לעיגול שלו. הוא עובד עד 50 אנשים.',
  'access.codes.labelPlaceholder': 'מפגש משפחתי',
  'access.validFor': 'בתוקף למשך',
  'access.revoke.title': 'לבטל את {what}?',
  'access.revoke.invite': 'קוד ההזמנה יפסיק לעבוד. תמיד אפשר ליצור להם הזמנה חדשה.',
  'access.revoke.temp': 'המכשיר ינותק בפעם הבאה שיפתחו אותו, והקוד יפסיק לעבוד. ההקלטות וכל מה שהוסיפו נשארים.',
  'access.revoke.code': 'אף אחד חדש לא יוכל להיכנס עם הקוד הזה. מי שכבר הצטרף איתו לא מושפע.',
  // ---- administrators ----
  'admins.rulesUndo': 'להחזיר',
  // ---- accounts & helpers ----
  'roles.accounts': 'חשבונות',
  'roles.signedInAs': 'מחובר/ת בתור {name}',
  'roles.notConnected': 'עדיין לא מחובר/ת לאף אחד בעץ',
  'roles.adminByAgreement': 'מנהלים נבחרים בהסכמה',
  'roles.changed': '{name} עכשיו: {role}.',
  'roles.explain': 'עורך/ת משפחה יכול/ה לאשר שינויים של המשפחה, לענות לדיווחים ולשלוח הזמנות. חבר/ה מוסיף/ה ומציע/ה. מנהלים לא נבחרים כאן — הרשימה משתנה רק כשהמנהלים מסכימים.',
  'roles.helpers.none': 'עדיין אף אחד לא עוזר בפרופיל של מישהו אחר.',
  'roles.helpedBy': 'בעזרת {name}',
  'roles.granted': 'בוצע. מעכשיו הם יכולים לעזור.',
  'roles.grant.choose': 'בחירת חשבון…',
  'roles.disconnected': 'נותק. העיגול וכל מה שעליו נשארים.',
  'roles.disconnect.short': 'ניתוק מהעיגול הזה',
  'roles.disconnect.body': '{account} כבר לא יהיה מחובר בתור {name}. זה מיועד למקרה שמישהו שייך את עצמו לאדם הלא נכון. העיגול, הסיפורים והתמונות נשארים, ואחר כך אפשר לחבר את החשבון לאדם הנכון.',
  'roles.disconnect.confirm': 'ניתוק',
  'roles.revoked': 'הוסר. הם כבר לא יכולים לעזור בפרופיל הזה.',
  'roles.revoke.title': 'להפסיק את העזרה הזאת?',
  'roles.revoke.body': '{helper} כבר לא יוכל לנהל את הפרופיל של {name}. מה שכבר נוסף נשאר.',
  'roles.error.adminByAgreement': 'מנהלים משתנים רק בהסכמה. כדי להציע מנהל או לפרוש, היכנסו ל«מנהלים».',
  // ---- locked records ----
  'locks.add': 'נעילת עיגול',
  'locks.none': 'שום דבר לא נעול.',
  'locks.people': 'עיגולים נעולים',
  'locks.connections': 'קשרים נעולים',
  'locks.stories': 'סיפורים נעולים',
  'locks.rel.partner': 'בני זוג',
  'locks.rel.parent_child': 'הורה וילד',
  'locks.unlocked': 'הנעילה של {name} שוחררה.',
  'locks.unlockedPlain': 'שוחרר.',
  'locks.locked': '{name} ננעל/ה. שינויים יגיעו למנהלים כהצעות.',
  'locks.who': 'העיגול של מי?',
  'locks.what': 'כמה ממנו?',
  'locks.whole': 'העיגול כולו',
  'locks.whole.help': 'למי שהלך לעולמו, או שעדיין לא יכול להצטרף. כל שינוי הופך להצעה.',
  'locks.some': 'רק חלק מהפרטים',
  'locks.some.help': 'לשם או לתאריך שנבדקו מול הרישומים של המשפחה.',
  'locks.reasonPlaceholder': 'נבדק מול פנקס המשפחה',
  'locks.field.names': 'שמות',
  'locks.field.birth': 'תאריך לידה',
  'locks.field.death': 'תאריך פטירה',
  'locks.field.status': 'בחיים או נפטר/ה',
  'locks.field.gender': 'מגדר',
  // ---- stories & recipes ----
  'moderation.search': 'חיפוש בסיפורים ובמתכונים',
  'moderation.filter.locked': 'נעולים',
  'moderation.filter.down': 'הורדו',
  'moderation.noneDown': 'שום דבר לא הורד.',
  'moderation.none': 'אין התאמה.',
  'moderation.restored': 'חזר למקום שבו המשפחה רואה אותו.',
  'moderation.lockedNow': 'ננעל. שינויים בו יגיעו מעכשיו כהצעות.',
  'moderation.takenDown': 'הורד. הוא נשמר, ואפשר להחזיר אותו מכאן.',
  'moderation.archive.title': 'להוריד את הסיפור הזה?',
  'moderation.archive.body': 'המשפחה תפסיק לראות אותו. ההקלטה וכל מה שקשור אליה נשמרים, וכל מנהל יכול להחזיר אותו מכאן.',
  // ---- decisions, uploads, history ----
  'decisions.emptyRemovals': 'שום תמונה לא הוסרה.',
  'decisions.newestFirst': 'מהחדש לישן',
  'jobs.none': 'שום דבר לא תקוע. כל ההקלטות עלו וגובו.',
  'audit.none': 'עדיין לא נרשם דבר.',
  'audit.putBack': 'להחזיר',
  'audit.restore.body': 'נוצר שינוי חדש שמחזיר את הדברים לקדמותם. ההיסטוריה שומרת את שניהם, כך שגם את זה אפשר לבטל.',
};
